import '../../assets/DatePicker.css';var Fn = Object.defineProperty;
var An = (n, a, t) => a in n ? Fn(n, a, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[a] = t;
var b = (n, a, t) => An(n, typeof a != "symbol" ? a + "" : a, t);
import { jsx as ct, jsxs as Hn } from "react/jsx-runtime";
import * as P from "react";
import m, { useLayoutEffect as tn, useEffect as lr, createElement as Wn, cloneElement as rn, Component as J, createRef as Pe, useRef as kt, useCallback as Bn, useState as Qn, forwardRef as Kn } from "react";
import { a as we, b as Te } from "../../addMonths-BDf46gmB.mjs";
import { t as x, c as G, m as Lt, a as Ft, s as Je, d as et, g as cr, b as Vn, e as Un, h as xt, i as nn, j as qn, k as an, l as on, n as $n, o as Zt, p as jn, w as kr, q as zn, r as Se, u as Jt, f as er, v as ur } from "../../format-plq8pBNY.mjs";
import { s as Qe, a as Xn } from "../../subMonths-nbU1oDhB.mjs";
import { r as Gn, R as Zn } from "../../index-DC7FmJPK.mjs";
import { Input as Jn } from "../Input/Input.js";
function dr(n, a) {
  const t = +x(n);
  return G(n, t + a);
}
function ea(n, a) {
  return dr(n, a * Lt);
}
function tr(n, a) {
  return dr(n, a * Ft);
}
function pr(n, a) {
  const t = a * 3;
  return we(n, t);
}
function ta(n, a) {
  return dr(n, a * 1e3);
}
function Mt(n, a) {
  const t = a * 7;
  return Te(n, t);
}
function ke(n, a) {
  return we(n, a * 12);
}
function xr(n) {
  let a;
  return n.forEach(function(t) {
    const e = x(t);
    (a === void 0 || a < e || isNaN(Number(e))) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function Mr(n) {
  let a;
  return n.forEach((t) => {
    const e = x(t);
    (!a || a > e || isNaN(+e)) && (a = e);
  }), a || /* @__PURE__ */ new Date(NaN);
}
function ra(n, a) {
  const t = Je(n), e = Je(a);
  return +t == +e;
}
function Ct(n, a) {
  const t = x(n), e = x(a), r = t.getFullYear() - e.getFullYear(), o = t.getMonth() - e.getMonth();
  return r * 12 + o;
}
function Ye(n) {
  const a = x(n);
  return Math.trunc(a.getMonth() / 3) + 1;
}
function St(n, a) {
  const t = x(n), e = x(a), r = t.getFullYear() - e.getFullYear(), o = Ye(t) - Ye(e);
  return r * 4 + o;
}
function Et(n, a) {
  const t = x(n), e = x(a);
  return t.getFullYear() - e.getFullYear();
}
function na(n, a) {
  const t = x(n), e = x(a), r = Cr(t, e), o = Math.abs(et(t, e));
  t.setDate(t.getDate() - r * o);
  const s = +(Cr(t, e) === -r), i = r * (o - s);
  return i === 0 ? 0 : i;
}
function Cr(n, a) {
  const t = n.getFullYear() - a.getFullYear() || n.getMonth() - a.getMonth() || n.getDate() - a.getDate() || n.getHours() - a.getHours() || n.getMinutes() - a.getMinutes() || n.getSeconds() - a.getSeconds() || n.getMilliseconds() - a.getMilliseconds();
  return t < 0 ? -1 : t > 0 ? 1 : t;
}
function sn(n) {
  const a = x(n);
  return a.setHours(23, 59, 59, 999), a;
}
function ln(n) {
  const a = x(n), t = a.getMonth();
  return a.setFullYear(a.getFullYear(), t + 1, 0), a.setHours(23, 59, 59, 999), a;
}
function rr(n) {
  const a = x(n), t = a.getMonth(), e = t - t % 3;
  return a.setMonth(e, 1), a.setHours(0, 0, 0, 0), a;
}
function cn(n) {
  const a = x(n);
  return a.setDate(1), a.setHours(0, 0, 0, 0), a;
}
function un(n) {
  const a = x(n), t = a.getFullYear();
  return a.setFullYear(t + 1, 0, 0), a.setHours(23, 59, 59, 999), a;
}
function aa(n, a) {
  var i, l;
  const t = cr(), e = t.weekStartsOn ?? ((l = (i = t.locale) == null ? void 0 : i.options) == null ? void 0 : l.weekStartsOn) ?? 0, r = x(n), o = r.getDay(), s = (o < e ? -7 : 0) + 6 - (o - e);
  return r.setDate(r.getDate() + s), r.setHours(23, 59, 59, 999), r;
}
function Sr(n) {
  return x(n).getDate();
}
function oa(n) {
  return x(n).getDay();
}
function sa(n) {
  const a = x(n), t = a.getFullYear(), e = a.getMonth(), r = G(n, 0);
  return r.setFullYear(t, e + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function ia() {
  return Object.assign({}, cr());
}
function ve(n) {
  return x(n).getHours();
}
function la(n) {
  let t = x(n).getDay();
  return t === 0 && (t = 7), t;
}
function ge(n) {
  return x(n).getMinutes();
}
function ne(n) {
  return x(n).getMonth();
}
function xe(n) {
  return x(n).getSeconds();
}
function nr(n) {
  return x(n).getTime();
}
function R(n) {
  return x(n).getFullYear();
}
function Oe(n, a) {
  const t = x(n), e = x(a);
  return t.getTime() > e.getTime();
}
function Fe(n, a) {
  const t = x(n), e = x(a);
  return +t < +e;
}
function ca(n, a) {
  const t = x(n), e = x(a);
  return +t == +e;
}
function ua(n, a) {
  const t = a instanceof Date ? G(a, 0) : new a(0);
  return t.setFullYear(
    n.getFullYear(),
    n.getMonth(),
    n.getDate()
  ), t.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), t;
}
const da = 10;
class dn {
  constructor() {
    b(this, "subPriority", 0);
  }
  validate(a, t) {
    return !0;
  }
}
class pa extends dn {
  constructor(a, t, e, r, o) {
    super(), this.value = a, this.validateValue = t, this.setValue = e, this.priority = r, o && (this.subPriority = o);
  }
  validate(a, t) {
    return this.validateValue(a, this.value, t);
  }
  set(a, t, e) {
    return this.setValue(a, t, this.value, e);
  }
}
class fa extends dn {
  constructor() {
    super(...arguments);
    b(this, "priority", da);
    b(this, "subPriority", -1);
  }
  set(t, e) {
    return e.timestampIsSet ? t : G(t, ua(t, Date));
  }
}
class H {
  run(a, t, e, r) {
    const o = this.parse(a, t, e, r);
    return o ? {
      setter: new pa(
        o.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: o.rest
    } : null;
  }
  validate(a, t, e) {
    return !0;
  }
}
class ha extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 140);
    b(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
      case "GGGGG":
        return r.era(t, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(t, { width: "wide" }) || r.era(t, { width: "abbreviated" }) || r.era(t, { width: "narrow" });
    }
  }
  set(t, e, r) {
    return e.era = r, t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
const j = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, fe = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function z(n, a) {
  return n && {
    value: a(n.value),
    rest: n.rest
  };
}
function q(n, a) {
  const t = a.match(n);
  return t ? {
    value: parseInt(t[0], 10),
    rest: a.slice(t[0].length)
  } : null;
}
function he(n, a) {
  const t = a.match(n);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: a.slice(1)
    };
  const e = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, o = t[3] ? parseInt(t[3], 10) : 0, s = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: e * (r * Lt + o * Ft + s * Vn),
    rest: a.slice(t[0].length)
  };
}
function pn(n) {
  return q(j.anyDigitsSigned, n);
}
function $(n, a) {
  switch (n) {
    case 1:
      return q(j.singleDigit, a);
    case 2:
      return q(j.twoDigits, a);
    case 3:
      return q(j.threeDigits, a);
    case 4:
      return q(j.fourDigits, a);
    default:
      return q(new RegExp("^\\d{1," + n + "}"), a);
  }
}
function Pt(n, a) {
  switch (n) {
    case 1:
      return q(j.singleDigitSigned, a);
    case 2:
      return q(j.twoDigitsSigned, a);
    case 3:
      return q(j.threeDigitsSigned, a);
    case 4:
      return q(j.fourDigitsSigned, a);
    default:
      return q(new RegExp("^-?\\d{1," + n + "}"), a);
  }
}
function fr(n) {
  switch (n) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function fn(n, a) {
  const t = a > 0, e = t ? a : 1 - a;
  let r;
  if (e <= 50)
    r = n || 100;
  else {
    const o = e + 50, s = Math.trunc(o / 100) * 100, i = n >= o % 100;
    r = n + s - (i ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function hn(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
class ma extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "yy"
    });
    switch (e) {
      case "y":
        return z($(4, t), o);
      case "yo":
        return z(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r) {
    const o = t.getFullYear();
    if (r.isTwoDigitYear) {
      const i = fn(
        r.year,
        o
      );
      return t.setFullYear(i, 0, 1), t.setHours(0, 0, 0, 0), t;
    }
    const s = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(s, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class va extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => ({
      year: s,
      isTwoDigitYear: e === "YY"
    });
    switch (e) {
      case "Y":
        return z($(4, t), o);
      case "Yo":
        return z(
          r.ordinalNumber(t, {
            unit: "year"
          }),
          o
        );
      default:
        return z($(e.length, t), o);
    }
  }
  validate(t, e) {
    return e.isTwoDigitYear || e.year > 0;
  }
  set(t, e, r, o) {
    const s = Un(t, o);
    if (r.isTwoDigitYear) {
      const l = fn(
        r.year,
        s
      );
      return t.setFullYear(
        l,
        0,
        o.firstWeekContainsDate
      ), t.setHours(0, 0, 0, 0), xt(t, o);
    }
    const i = !("era" in e) || e.era === 1 ? r.year : 1 - r.year;
    return t.setFullYear(i, 0, o.firstWeekContainsDate), t.setHours(0, 0, 0, 0), xt(t, o);
  }
}
class ga extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e) {
    return Pt(e === "R" ? 4 : e.length, t);
  }
  set(t, e, r) {
    const o = G(t, 0);
    return o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0), nn(o);
  }
}
class Da extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 130);
    b(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(t, e) {
    return Pt(e === "u" ? 4 : e.length, t);
  }
  set(t, e, r) {
    return t.setFullYear(r, 0, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class wa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 120);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "Q":
      case "QQ":
        return $(e.length, t);
      case "Qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "QQQ":
        return r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ya extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 120);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "q":
      case "qq":
        return $(e.length, t);
      case "qo":
        return r.ordinalNumber(t, { unit: "quarter" });
      case "qqq":
        return r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(t, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(t, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 4;
  }
  set(t, e, r) {
    return t.setMonth((r - 1) * 3, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class ba extends H {
  constructor() {
    super(...arguments);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    b(this, "priority", 110);
  }
  parse(t, e, r) {
    const o = (s) => s - 1;
    switch (e) {
      case "M":
        return z(
          q(j.month, t),
          o
        );
      case "MM":
        return z($(2, t), o);
      case "Mo":
        return z(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "MMM":
        return r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return r.month(t, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(t, { width: "wide", context: "formatting" }) || r.month(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
class _a extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 110);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => s - 1;
    switch (e) {
      case "L":
        return z(
          q(j.month, t),
          o
        );
      case "LL":
        return z($(2, t), o);
      case "Lo":
        return z(
          r.ordinalNumber(t, {
            unit: "month"
          }),
          o
        );
      case "LLL":
        return r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return r.month(t, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(t, { width: "wide", context: "standalone" }) || r.month(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.setMonth(r, 1), t.setHours(0, 0, 0, 0), t;
  }
}
function ka(n, a, t) {
  const e = x(n), r = qn(e, t) - a;
  return e.setDate(e.getDate() - r * 7), e;
}
class xa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 100);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "w":
        return q(j.week, t);
      case "wo":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r, o) {
    return xt(ka(t, r, o), o);
  }
}
function Ma(n, a) {
  const t = x(n), e = an(t) - a;
  return t.setDate(t.getDate() - e * 7), t;
}
class Ca extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 100);
    b(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "I":
        return q(j.week, t);
      case "Io":
        return r.ordinalNumber(t, { unit: "week" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 53;
  }
  set(t, e, r) {
    return nn(Ma(t, r));
  }
}
const Sa = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], Ea = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class Pa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "subPriority", 1);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "d":
        return q(j.date, t);
      case "do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear(), o = hn(r), s = t.getMonth();
    return o ? e >= 1 && e <= Ea[s] : e >= 1 && e <= Sa[s];
  }
  set(t, e, r) {
    return t.setDate(r), t.setHours(0, 0, 0, 0), t;
  }
}
class Ta extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "subpriority", 1);
    b(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    switch (e) {
      case "D":
      case "DD":
        return q(j.dayOfYear, t);
      case "Do":
        return r.ordinalNumber(t, { unit: "date" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    const r = t.getFullYear();
    return hn(r) ? e >= 1 && e <= 366 : e >= 1 && e <= 365;
  }
  set(t, e, r) {
    return t.setMonth(0, r), t.setHours(0, 0, 0, 0), t;
  }
}
function hr(n, a, t) {
  var d, p, f, h;
  const e = cr(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((p = (d = t == null ? void 0 : t.locale) == null ? void 0 : d.options) == null ? void 0 : p.weekStartsOn) ?? e.weekStartsOn ?? ((h = (f = e.locale) == null ? void 0 : f.options) == null ? void 0 : h.weekStartsOn) ?? 0, o = x(n), s = o.getDay(), l = (a % 7 + 7) % 7, c = 7 - r, u = a < 0 || a > 6 ? a - (s + c) % 7 : (l + c) % 7 - (s + c) % 7;
  return Te(o, u);
}
class Oa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = hr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Na extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const s = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      case "e":
      case "ee":
        return z($(e.length, t), s);
      case "eo":
        return z(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "eee":
        return r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeeee":
        return r.day(t, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return r.day(t, { width: "wide", context: "formatting" }) || r.day(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(t, { width: "short", context: "formatting" }) || r.day(t, { width: "narrow", context: "formatting" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = hr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
class Ra extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(t, e, r, o) {
    const s = (i) => {
      const l = Math.floor((i - 1) / 7) * 7;
      return (i + o.weekStartsOn + 6) % 7 + l;
    };
    switch (e) {
      case "c":
      case "cc":
        return z($(e.length, t), s);
      case "co":
        return z(
          r.ordinalNumber(t, {
            unit: "day"
          }),
          s
        );
      case "ccc":
        return r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "ccccc":
        return r.day(t, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return r.day(t, { width: "wide", context: "standalone" }) || r.day(t, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(t, { width: "short", context: "standalone" }) || r.day(t, { width: "narrow", context: "standalone" });
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 6;
  }
  set(t, e, r, o) {
    return t = hr(t, r, o), t.setHours(0, 0, 0, 0), t;
  }
}
function Ya(n, a) {
  const t = x(n), e = la(t), r = a - e;
  return Te(t, r);
}
class Ia extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 90);
    b(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(t, e, r) {
    const o = (s) => s === 0 ? 7 : s;
    switch (e) {
      case "i":
      case "ii":
        return $(e.length, t);
      case "io":
        return r.ordinalNumber(t, { unit: "day" });
      case "iii":
        return z(
          r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiii":
        return z(
          r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiiiii":
        return z(
          r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
      case "iiii":
      default:
        return z(
          r.day(t, {
            width: "wide",
            context: "formatting"
          }) || r.day(t, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(t, {
            width: "short",
            context: "formatting"
          }) || r.day(t, {
            width: "narrow",
            context: "formatting"
          }),
          o
        );
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 7;
  }
  set(t, e, r) {
    return t = Ya(t, r), t.setHours(0, 0, 0, 0), t;
  }
}
class La extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(fr(r), 0, 0, 0), t;
  }
}
class Fa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(fr(r), 0, 0, 0), t;
  }
}
class Aa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 80);
    b(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(t, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(t, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(t, e, r) {
    return t.setHours(fr(r), 0, 0, 0), t;
  }
}
class Ha extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "h":
        return q(j.hour12h, t);
      case "ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 12;
  }
  set(t, e, r) {
    const o = t.getHours() >= 12;
    return o && r < 12 ? t.setHours(r + 12, 0, 0, 0) : !o && r === 12 ? t.setHours(0, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class Wa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "H":
        return q(j.hour23h, t);
      case "Ho":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 23;
  }
  set(t, e, r) {
    return t.setHours(r, 0, 0, 0), t;
  }
}
class Ba extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "K":
        return q(j.hour11h, t);
      case "Ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 11;
  }
  set(t, e, r) {
    return t.getHours() >= 12 && r < 12 ? t.setHours(r + 12, 0, 0, 0) : t.setHours(r, 0, 0, 0), t;
  }
}
class Qa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 70);
    b(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "k":
        return q(j.hour24h, t);
      case "ko":
        return r.ordinalNumber(t, { unit: "hour" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 1 && e <= 24;
  }
  set(t, e, r) {
    const o = r <= 24 ? r % 24 : r;
    return t.setHours(o, 0, 0, 0), t;
  }
}
class Ka extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 60);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "m":
        return q(j.minute, t);
      case "mo":
        return r.ordinalNumber(t, { unit: "minute" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setMinutes(r, 0, 0), t;
  }
}
class Va extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 50);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e, r) {
    switch (e) {
      case "s":
        return q(j.second, t);
      case "so":
        return r.ordinalNumber(t, { unit: "second" });
      default:
        return $(e.length, t);
    }
  }
  validate(t, e) {
    return e >= 0 && e <= 59;
  }
  set(t, e, r) {
    return t.setSeconds(r, 0), t;
  }
}
class Ua extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 30);
    b(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(t, e) {
    const r = (o) => Math.trunc(o * Math.pow(10, -e.length + 3));
    return z($(e.length, t), r);
  }
  set(t, e, r) {
    return t.setMilliseconds(r), t;
  }
}
class qa extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 10);
    b(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(t, e) {
    switch (e) {
      case "X":
        return he(
          fe.basicOptionalMinutes,
          t
        );
      case "XX":
        return he(fe.basic, t);
      case "XXXX":
        return he(
          fe.basicOptionalSeconds,
          t
        );
      case "XXXXX":
        return he(
          fe.extendedOptionalSeconds,
          t
        );
      case "XXX":
      default:
        return he(fe.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : G(
      t,
      t.getTime() - on(t) - r
    );
  }
}
class $a extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 10);
    b(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(t, e) {
    switch (e) {
      case "x":
        return he(
          fe.basicOptionalMinutes,
          t
        );
      case "xx":
        return he(fe.basic, t);
      case "xxxx":
        return he(
          fe.basicOptionalSeconds,
          t
        );
      case "xxxxx":
        return he(
          fe.extendedOptionalSeconds,
          t
        );
      case "xxx":
      default:
        return he(fe.extended, t);
    }
  }
  set(t, e, r) {
    return e.timestampIsSet ? t : G(
      t,
      t.getTime() - on(t) - r
    );
  }
}
class ja extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 40);
    b(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return pn(t);
  }
  set(t, e, r) {
    return [G(t, r * 1e3), { timestampIsSet: !0 }];
  }
}
class za extends H {
  constructor() {
    super(...arguments);
    b(this, "priority", 20);
    b(this, "incompatibleTokens", "*");
  }
  parse(t) {
    return pn(t);
  }
  set(t, e, r) {
    return [G(t, r), { timestampIsSet: !0 }];
  }
}
const Xa = {
  G: new ha(),
  y: new ma(),
  Y: new va(),
  R: new ga(),
  u: new Da(),
  Q: new wa(),
  q: new ya(),
  M: new ba(),
  L: new _a(),
  w: new xa(),
  I: new Ca(),
  d: new Pa(),
  D: new Ta(),
  E: new Oa(),
  e: new Na(),
  c: new Ra(),
  i: new Ia(),
  a: new La(),
  b: new Fa(),
  B: new Aa(),
  h: new Ha(),
  H: new Wa(),
  K: new Ba(),
  k: new Qa(),
  m: new Ka(),
  s: new Va(),
  S: new Ua(),
  X: new qa(),
  x: new $a(),
  t: new ja(),
  T: new za()
}, Ga = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Za = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ja = /^'([^]*?)'?$/, eo = /''/g, to = /\S/, ro = /[a-zA-Z]/;
function Kt(n, a, t, e) {
  var v, g, D, M, k, E, S, O;
  const r = ia(), o = (e == null ? void 0 : e.locale) ?? r.locale ?? $n, s = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((g = (v = e == null ? void 0 : e.locale) == null ? void 0 : v.options) == null ? void 0 : g.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((M = (D = r.locale) == null ? void 0 : D.options) == null ? void 0 : M.firstWeekContainsDate) ?? 1, i = (e == null ? void 0 : e.weekStartsOn) ?? ((E = (k = e == null ? void 0 : e.locale) == null ? void 0 : k.options) == null ? void 0 : E.weekStartsOn) ?? r.weekStartsOn ?? ((O = (S = r.locale) == null ? void 0 : S.options) == null ? void 0 : O.weekStartsOn) ?? 0;
  if (a === "")
    return n === "" ? x(t) : G(t, NaN);
  const l = {
    firstWeekContainsDate: s,
    weekStartsOn: i,
    locale: o
  }, c = [new fa()], u = a.match(Za).map((y) => {
    const _ = y[0];
    if (_ in Zt) {
      const C = Zt[_];
      return C(y, o.formatLong);
    }
    return y;
  }).join("").match(Ga), d = [];
  for (let y of u) {
    !(e != null && e.useAdditionalWeekYearTokens) && jn(y) && kr(y, a, n), !(e != null && e.useAdditionalDayOfYearTokens) && zn(y) && kr(y, a, n);
    const _ = y[0], C = Xa[_];
    if (C) {
      const { incompatibleTokens: L } = C;
      if (Array.isArray(L)) {
        const A = d.find(
          (K) => L.includes(K.token) || K.token === _
        );
        if (A)
          throw new RangeError(
            `The format string mustn't contain \`${A.fullToken}\` and \`${y}\` at the same time`
          );
      } else if (C.incompatibleTokens === "*" && d.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${y}\` and any other token at the same time`
        );
      d.push({ token: _, fullToken: y });
      const W = C.run(
        n,
        y,
        o.match,
        l
      );
      if (!W)
        return G(t, NaN);
      c.push(W.setter), n = W.rest;
    } else {
      if (_.match(ro))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + _ + "`"
        );
      if (y === "''" ? y = "'" : _ === "'" && (y = no(y)), n.indexOf(y) === 0)
        n = n.slice(y.length);
      else
        return G(t, NaN);
    }
  }
  if (n.length > 0 && to.test(n))
    return G(t, NaN);
  const p = c.map((y) => y.priority).sort((y, _) => _ - y).filter((y, _, C) => C.indexOf(y) === _).map(
    (y) => c.filter((_) => _.priority === y).sort((_, C) => C.subPriority - _.subPriority)
  ).map((y) => y[0]);
  let f = x(t);
  if (isNaN(f.getTime()))
    return G(t, NaN);
  const h = {};
  for (const y of p) {
    if (!y.validate(f, l))
      return G(t, NaN);
    const _ = y.set(f, h, l);
    Array.isArray(_) ? (f = _[0], Object.assign(h, _[1])) : f = _;
  }
  return G(t, f);
}
function no(n) {
  return n.match(Ja)[1].replace(eo, "'");
}
function ao(n, a) {
  const t = x(n), e = x(a);
  return t.getFullYear() === e.getFullYear() && t.getMonth() === e.getMonth();
}
function oo(n, a) {
  const t = rr(n), e = rr(a);
  return +t == +e;
}
function so(n, a) {
  const t = x(n), e = x(a);
  return t.getFullYear() === e.getFullYear();
}
function tt(n, a) {
  const t = +x(n), [e, r] = [
    +x(a.start),
    +x(a.end)
  ].sort((o, s) => o - s);
  return t >= e && t <= r;
}
function io(n, a) {
  const e = po(n);
  let r;
  if (e.date) {
    const l = fo(e.date, 2);
    r = ho(l.restDateString, l.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const o = r.getTime();
  let s = 0, i;
  if (e.time && (s = mo(e.time), isNaN(s)))
    return /* @__PURE__ */ new Date(NaN);
  if (e.timezone) {
    if (i = vo(e.timezone), isNaN(i))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const l = new Date(o + s), c = /* @__PURE__ */ new Date(0);
    return c.setFullYear(
      l.getUTCFullYear(),
      l.getUTCMonth(),
      l.getUTCDate()
    ), c.setHours(
      l.getUTCHours(),
      l.getUTCMinutes(),
      l.getUTCSeconds(),
      l.getUTCMilliseconds()
    ), c;
  }
  return new Date(o + s + i);
}
const ut = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, lo = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, co = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, uo = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function po(n) {
  const a = {}, t = n.split(ut.dateTimeDelimiter);
  let e;
  if (t.length > 2)
    return a;
  if (/:/.test(t[0]) ? e = t[0] : (a.date = t[0], e = t[1], ut.timeZoneDelimiter.test(a.date) && (a.date = n.split(ut.timeZoneDelimiter)[0], e = n.substr(
    a.date.length,
    n.length
  ))), e) {
    const r = ut.timezone.exec(e);
    r ? (a.time = e.replace(r[1], ""), a.timezone = r[1]) : a.time = e;
  }
  return a;
}
function fo(n, a) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + a) + "})|(\\d{2}|[+-]\\d{" + (2 + a) + "})$)"
  ), e = n.match(t);
  if (!e) return { year: NaN, restDateString: "" };
  const r = e[1] ? parseInt(e[1]) : null, o = e[2] ? parseInt(e[2]) : null;
  return {
    year: o === null ? r : o * 100,
    restDateString: n.slice((e[1] || e[2]).length)
  };
}
function ho(n, a) {
  if (a === null) return /* @__PURE__ */ new Date(NaN);
  const t = n.match(lo);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const e = !!t[4], r = je(t[1]), o = je(t[2]) - 1, s = je(t[3]), i = je(t[4]), l = je(t[5]) - 1;
  if (e)
    return bo(a, i, l) ? go(a, i, l) : /* @__PURE__ */ new Date(NaN);
  {
    const c = /* @__PURE__ */ new Date(0);
    return !wo(a, o, s) || !yo(a, r) ? /* @__PURE__ */ new Date(NaN) : (c.setUTCFullYear(a, o, Math.max(r, s)), c);
  }
}
function je(n) {
  return n ? parseInt(n) : 1;
}
function mo(n) {
  const a = n.match(co);
  if (!a) return NaN;
  const t = Vt(a[1]), e = Vt(a[2]), r = Vt(a[3]);
  return _o(t, e, r) ? t * Lt + e * Ft + r * 1e3 : NaN;
}
function Vt(n) {
  return n && parseFloat(n.replace(",", ".")) || 0;
}
function vo(n) {
  if (n === "Z") return 0;
  const a = n.match(uo);
  if (!a) return 0;
  const t = a[1] === "+" ? -1 : 1, e = parseInt(a[2]), r = a[3] && parseInt(a[3]) || 0;
  return ko(e, r) ? t * (e * Lt + r * Ft) : NaN;
}
function go(n, a, t) {
  const e = /* @__PURE__ */ new Date(0);
  e.setUTCFullYear(n, 0, 4);
  const r = e.getUTCDay() || 7, o = (a - 1) * 7 + t + 1 - r;
  return e.setUTCDate(e.getUTCDate() + o), e;
}
const Do = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function mn(n) {
  return n % 400 === 0 || n % 4 === 0 && n % 100 !== 0;
}
function wo(n, a, t) {
  return a >= 0 && a <= 11 && t >= 1 && t <= (Do[a] || (mn(n) ? 29 : 28));
}
function yo(n, a) {
  return a >= 1 && a <= (mn(n) ? 366 : 365);
}
function bo(n, a, t) {
  return a >= 1 && a <= 53 && t >= 0 && t <= 6;
}
function _o(n, a, t) {
  return n === 24 ? a === 0 && t === 0 : t >= 0 && t < 60 && a >= 0 && a < 60 && n >= 0 && n < 25;
}
function ko(n, a) {
  return a >= 0 && a <= 59;
}
function ae(n, a) {
  const t = x(n), e = t.getFullYear(), r = t.getDate(), o = G(n, 0);
  o.setFullYear(e, a, 15), o.setHours(0, 0, 0, 0);
  const s = sa(o);
  return t.setMonth(a, Math.min(r, s)), t;
}
function xo(n, a) {
  let t = x(n);
  return isNaN(+t) ? G(n, NaN) : (a.year != null && t.setFullYear(a.year), a.month != null && (t = ae(t, a.month)), a.date != null && t.setDate(a.date), a.hours != null && t.setHours(a.hours), a.minutes != null && t.setMinutes(a.minutes), a.seconds != null && t.setSeconds(a.seconds), a.milliseconds != null && t.setMilliseconds(a.milliseconds), t);
}
function gt(n, a) {
  const t = x(n);
  return t.setHours(a), t;
}
function Dt(n, a) {
  const t = x(n);
  return t.setMinutes(a), t;
}
function He(n, a) {
  const t = x(n), e = Math.trunc(t.getMonth() / 3) + 1, r = a - e;
  return ae(t, t.getMonth() + r * 3);
}
function wt(n, a) {
  const t = x(n);
  return t.setSeconds(a), t;
}
function de(n, a) {
  const t = x(n);
  return isNaN(+t) ? G(n, NaN) : (t.setFullYear(a), t);
}
function vn(n, a) {
  return pr(n, -a);
}
function Er(n, a) {
  return Mt(n, -a);
}
function Ke(n, a) {
  return ke(n, -a);
}
function gn(n) {
  var a, t, e = "";
  if (typeof n == "string" || typeof n == "number") e += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (a = 0; a < r; a++) n[a] && (t = gn(n[a])) && (e && (e += " "), e += t);
  } else for (t in n) n[t] && (e && (e += " "), e += t);
  return e;
}
function Z() {
  for (var n, a, t = 0, e = "", r = arguments.length; t < r; t++) (n = arguments[t]) && (a = gn(n)) && (e && (e += " "), e += a);
  return e;
}
function At() {
  return typeof window < "u";
}
function $e(n) {
  return Dn(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function oe(n) {
  var a;
  return (n == null || (a = n.ownerDocument) == null ? void 0 : a.defaultView) || window;
}
function be(n) {
  var a;
  return (a = (Dn(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : a.documentElement;
}
function Dn(n) {
  return At() ? n instanceof Node || n instanceof oe(n).Node : !1;
}
function te(n) {
  return At() ? n instanceof Element || n instanceof oe(n).Element : !1;
}
function ye(n) {
  return At() ? n instanceof HTMLElement || n instanceof oe(n).HTMLElement : !1;
}
function Pr(n) {
  return !At() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof oe(n).ShadowRoot;
}
function ot(n) {
  const {
    overflow: a,
    overflowX: t,
    overflowY: e,
    display: r
  } = le(n);
  return /auto|scroll|overlay|hidden|clip/.test(a + e + t) && !["inline", "contents"].includes(r);
}
function Mo(n) {
  return ["table", "td", "th"].includes($e(n));
}
function Ht(n) {
  return [":popover-open", ":modal"].some((a) => {
    try {
      return n.matches(a);
    } catch {
      return !1;
    }
  });
}
function mr(n) {
  const a = vr(), t = te(n) ? le(n) : n;
  return t.transform !== "none" || t.perspective !== "none" || (t.containerType ? t.containerType !== "normal" : !1) || !a && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !a && (t.filter ? t.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((e) => (t.willChange || "").includes(e)) || ["paint", "layout", "strict", "content"].some((e) => (t.contain || "").includes(e));
}
function Co(n) {
  let a = Ne(n);
  for (; ye(a) && !Ve(a); ) {
    if (mr(a))
      return a;
    if (Ht(a))
      return null;
    a = Ne(a);
  }
  return null;
}
function vr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Ve(n) {
  return ["html", "body", "#document"].includes($e(n));
}
function le(n) {
  return oe(n).getComputedStyle(n);
}
function Wt(n) {
  return te(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function Ne(n) {
  if ($e(n) === "html")
    return n;
  const a = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    Pr(n) && n.host || // Fallback.
    be(n)
  );
  return Pr(a) ? a.host : a;
}
function wn(n) {
  const a = Ne(n);
  return Ve(a) ? n.ownerDocument ? n.ownerDocument.body : n.body : ye(a) && ot(a) ? a : wn(a);
}
function rt(n, a, t) {
  var e;
  a === void 0 && (a = []), t === void 0 && (t = !0);
  const r = wn(n), o = r === ((e = n.ownerDocument) == null ? void 0 : e.body), s = oe(r);
  if (o) {
    const i = ar(s);
    return a.concat(s, s.visualViewport || [], ot(r) ? r : [], i && t ? rt(i) : []);
  }
  return a.concat(r, rt(r, [], t));
}
function ar(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
const Ue = Math.min, Ie = Math.max, Tt = Math.round, dt = Math.floor, De = (n) => ({
  x: n,
  y: n
}), So = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Eo = {
  start: "end",
  end: "start"
};
function Po(n, a, t) {
  return Ie(n, Ue(a, t));
}
function Bt(n, a) {
  return typeof n == "function" ? n(a) : n;
}
function qe(n) {
  return n.split("-")[0];
}
function st(n) {
  return n.split("-")[1];
}
function To(n) {
  return n === "x" ? "y" : "x";
}
function gr(n) {
  return n === "y" ? "height" : "width";
}
function nt(n) {
  return ["top", "bottom"].includes(qe(n)) ? "y" : "x";
}
function Dr(n) {
  return To(nt(n));
}
function Oo(n, a, t) {
  t === void 0 && (t = !1);
  const e = st(n), r = Dr(n), o = gr(r);
  let s = r === "x" ? e === (t ? "end" : "start") ? "right" : "left" : e === "start" ? "bottom" : "top";
  return a.reference[o] > a.floating[o] && (s = Ot(s)), [s, Ot(s)];
}
function No(n) {
  const a = Ot(n);
  return [or(n), a, or(a)];
}
function or(n) {
  return n.replace(/start|end/g, (a) => Eo[a]);
}
function Ro(n, a, t) {
  const e = ["left", "right"], r = ["right", "left"], o = ["top", "bottom"], s = ["bottom", "top"];
  switch (n) {
    case "top":
    case "bottom":
      return t ? a ? r : e : a ? e : r;
    case "left":
    case "right":
      return a ? o : s;
    default:
      return [];
  }
}
function Yo(n, a, t, e) {
  const r = st(n);
  let o = Ro(qe(n), t === "start", e);
  return r && (o = o.map((s) => s + "-" + r), a && (o = o.concat(o.map(or)))), o;
}
function Ot(n) {
  return n.replace(/left|right|bottom|top/g, (a) => So[a]);
}
function Io(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function yn(n) {
  return typeof n != "number" ? Io(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function Nt(n) {
  const {
    x: a,
    y: t,
    width: e,
    height: r
  } = n;
  return {
    width: e,
    height: r,
    top: t,
    left: a,
    right: a + e,
    bottom: t + r,
    x: a,
    y: t
  };
}
function Tr(n, a, t) {
  let {
    reference: e,
    floating: r
  } = n;
  const o = nt(a), s = Dr(a), i = gr(s), l = qe(a), c = o === "y", u = e.x + e.width / 2 - r.width / 2, d = e.y + e.height / 2 - r.height / 2, p = e[i] / 2 - r[i] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: u,
        y: e.y - r.height
      };
      break;
    case "bottom":
      f = {
        x: u,
        y: e.y + e.height
      };
      break;
    case "right":
      f = {
        x: e.x + e.width,
        y: d
      };
      break;
    case "left":
      f = {
        x: e.x - r.width,
        y: d
      };
      break;
    default:
      f = {
        x: e.x,
        y: e.y
      };
  }
  switch (st(a)) {
    case "start":
      f[s] -= p * (t && c ? -1 : 1);
      break;
    case "end":
      f[s] += p * (t && c ? -1 : 1);
      break;
  }
  return f;
}
const Lo = async (n, a, t) => {
  const {
    placement: e = "bottom",
    strategy: r = "absolute",
    middleware: o = [],
    platform: s
  } = t, i = o.filter(Boolean), l = await (s.isRTL == null ? void 0 : s.isRTL(a));
  let c = await s.getElementRects({
    reference: n,
    floating: a,
    strategy: r
  }), {
    x: u,
    y: d
  } = Tr(c, e, l), p = e, f = {}, h = 0;
  for (let v = 0; v < i.length; v++) {
    const {
      name: g,
      fn: D
    } = i[v], {
      x: M,
      y: k,
      data: E,
      reset: S
    } = await D({
      x: u,
      y: d,
      initialPlacement: e,
      placement: p,
      strategy: r,
      middlewareData: f,
      rects: c,
      platform: s,
      elements: {
        reference: n,
        floating: a
      }
    });
    u = M ?? u, d = k ?? d, f = {
      ...f,
      [g]: {
        ...f[g],
        ...E
      }
    }, S && h <= 50 && (h++, typeof S == "object" && (S.placement && (p = S.placement), S.rects && (c = S.rects === !0 ? await s.getElementRects({
      reference: n,
      floating: a,
      strategy: r
    }) : S.rects), {
      x: u,
      y: d
    } = Tr(c, p, l)), v = -1);
  }
  return {
    x: u,
    y: d,
    placement: p,
    strategy: r,
    middlewareData: f
  };
};
async function Fo(n, a) {
  var t;
  a === void 0 && (a = {});
  const {
    x: e,
    y: r,
    platform: o,
    rects: s,
    elements: i,
    strategy: l
  } = n, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: p = !1,
    padding: f = 0
  } = Bt(a, n), h = yn(f), g = i[p ? d === "floating" ? "reference" : "floating" : d], D = Nt(await o.getClippingRect({
    element: (t = await (o.isElement == null ? void 0 : o.isElement(g))) == null || t ? g : g.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), M = d === "floating" ? {
    x: e,
    y: r,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, k = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(i.floating)), E = await (o.isElement == null ? void 0 : o.isElement(k)) ? await (o.getScale == null ? void 0 : o.getScale(k)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, S = Nt(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: M,
    offsetParent: k,
    strategy: l
  }) : M);
  return {
    top: (D.top - S.top + h.top) / E.y,
    bottom: (S.bottom - D.bottom + h.bottom) / E.y,
    left: (D.left - S.left + h.left) / E.x,
    right: (S.right - D.right + h.right) / E.x
  };
}
const Ao = (n) => ({
  name: "arrow",
  options: n,
  async fn(a) {
    const {
      x: t,
      y: e,
      placement: r,
      rects: o,
      platform: s,
      elements: i,
      middlewareData: l
    } = a, {
      element: c,
      padding: u = 0
    } = Bt(n, a) || {};
    if (c == null)
      return {};
    const d = yn(u), p = {
      x: t,
      y: e
    }, f = Dr(r), h = gr(f), v = await s.getDimensions(c), g = f === "y", D = g ? "top" : "left", M = g ? "bottom" : "right", k = g ? "clientHeight" : "clientWidth", E = o.reference[h] + o.reference[f] - p[f] - o.floating[h], S = p[f] - o.reference[f], O = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(c));
    let y = O ? O[k] : 0;
    (!y || !await (s.isElement == null ? void 0 : s.isElement(O))) && (y = i.floating[k] || o.floating[h]);
    const _ = E / 2 - S / 2, C = y / 2 - v[h] / 2 - 1, L = Ue(d[D], C), W = Ue(d[M], C), A = L, K = y - v[h] - W, V = y / 2 - v[h] / 2 + _, Q = Po(A, V, K), T = !l.arrow && st(r) != null && V !== Q && o.reference[h] / 2 - (V < A ? L : W) - v[h] / 2 < 0, Y = T ? V < A ? V - A : V - K : 0;
    return {
      [f]: p[f] + Y,
      data: {
        [f]: Q,
        centerOffset: V - Q - Y,
        ...T && {
          alignmentOffset: Y
        }
      },
      reset: T
    };
  }
}), Ho = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(a) {
      var t, e;
      const {
        placement: r,
        middlewareData: o,
        rects: s,
        initialPlacement: i,
        platform: l,
        elements: c
      } = a, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: p,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: v = !0,
        ...g
      } = Bt(n, a);
      if ((t = o.arrow) != null && t.alignmentOffset)
        return {};
      const D = qe(r), M = nt(i), k = qe(i) === i, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), S = p || (k || !v ? [Ot(i)] : No(i)), O = h !== "none";
      !p && O && S.push(...Yo(i, v, h, E));
      const y = [i, ...S], _ = await Fo(a, g), C = [];
      let L = ((e = o.flip) == null ? void 0 : e.overflows) || [];
      if (u && C.push(_[D]), d) {
        const V = Oo(r, s, E);
        C.push(_[V[0]], _[V[1]]);
      }
      if (L = [...L, {
        placement: r,
        overflows: C
      }], !C.every((V) => V <= 0)) {
        var W, A;
        const V = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, Q = y[V];
        if (Q)
          return {
            data: {
              index: V,
              overflows: L
            },
            reset: {
              placement: Q
            }
          };
        let T = (A = L.filter((Y) => Y.overflows[0] <= 0).sort((Y, N) => Y.overflows[1] - N.overflows[1])[0]) == null ? void 0 : A.placement;
        if (!T)
          switch (f) {
            case "bestFit": {
              var K;
              const Y = (K = L.filter((N) => {
                if (O) {
                  const X = nt(N.placement);
                  return X === M || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  X === "y";
                }
                return !0;
              }).map((N) => [N.placement, N.overflows.filter((X) => X > 0).reduce((X, ce) => X + ce, 0)]).sort((N, X) => N[1] - X[1])[0]) == null ? void 0 : K[0];
              Y && (T = Y);
              break;
            }
            case "initialPlacement":
              T = i;
              break;
          }
        if (r !== T)
          return {
            reset: {
              placement: T
            }
          };
      }
      return {};
    }
  };
};
async function Wo(n, a) {
  const {
    placement: t,
    platform: e,
    elements: r
  } = n, o = await (e.isRTL == null ? void 0 : e.isRTL(r.floating)), s = qe(t), i = st(t), l = nt(t) === "y", c = ["left", "top"].includes(s) ? -1 : 1, u = o && l ? -1 : 1, d = Bt(a, n);
  let {
    mainAxis: p,
    crossAxis: f,
    alignmentAxis: h
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return i && typeof h == "number" && (f = i === "end" ? h * -1 : h), l ? {
    x: f * u,
    y: p * c
  } : {
    x: p * c,
    y: f * u
  };
}
const Bo = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(a) {
      var t, e;
      const {
        x: r,
        y: o,
        placement: s,
        middlewareData: i
      } = a, l = await Wo(a, n);
      return s === ((t = i.offset) == null ? void 0 : t.placement) && (e = i.arrow) != null && e.alignmentOffset ? {} : {
        x: r + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: s
        }
      };
    }
  };
};
function bn(n) {
  const a = le(n);
  let t = parseFloat(a.width) || 0, e = parseFloat(a.height) || 0;
  const r = ye(n), o = r ? n.offsetWidth : t, s = r ? n.offsetHeight : e, i = Tt(t) !== o || Tt(e) !== s;
  return i && (t = o, e = s), {
    width: t,
    height: e,
    $: i
  };
}
function wr(n) {
  return te(n) ? n : n.contextElement;
}
function We(n) {
  const a = wr(n);
  if (!ye(a))
    return De(1);
  const t = a.getBoundingClientRect(), {
    width: e,
    height: r,
    $: o
  } = bn(a);
  let s = (o ? Tt(t.width) : t.width) / e, i = (o ? Tt(t.height) : t.height) / r;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const Qo = /* @__PURE__ */ De(0);
function _n(n) {
  const a = oe(n);
  return !vr() || !a.visualViewport ? Qo : {
    x: a.visualViewport.offsetLeft,
    y: a.visualViewport.offsetTop
  };
}
function Ko(n, a, t) {
  return a === void 0 && (a = !1), !t || a && t !== oe(n) ? !1 : a;
}
function Ae(n, a, t, e) {
  a === void 0 && (a = !1), t === void 0 && (t = !1);
  const r = n.getBoundingClientRect(), o = wr(n);
  let s = De(1);
  a && (e ? te(e) && (s = We(e)) : s = We(n));
  const i = Ko(o, t, e) ? _n(o) : De(0);
  let l = (r.left + i.x) / s.x, c = (r.top + i.y) / s.y, u = r.width / s.x, d = r.height / s.y;
  if (o) {
    const p = oe(o), f = e && te(e) ? oe(e) : e;
    let h = p, v = ar(h);
    for (; v && e && f !== h; ) {
      const g = We(v), D = v.getBoundingClientRect(), M = le(v), k = D.left + (v.clientLeft + parseFloat(M.paddingLeft)) * g.x, E = D.top + (v.clientTop + parseFloat(M.paddingTop)) * g.y;
      l *= g.x, c *= g.y, u *= g.x, d *= g.y, l += k, c += E, h = oe(v), v = ar(h);
    }
  }
  return Nt({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function yr(n, a) {
  const t = Wt(n).scrollLeft;
  return a ? a.left + t : Ae(be(n)).left + t;
}
function kn(n, a, t) {
  t === void 0 && (t = !1);
  const e = n.getBoundingClientRect(), r = e.left + a.scrollLeft - (t ? 0 : (
    // RTL <body> scrollbar.
    yr(n, e)
  )), o = e.top + a.scrollTop;
  return {
    x: r,
    y: o
  };
}
function Vo(n) {
  let {
    elements: a,
    rect: t,
    offsetParent: e,
    strategy: r
  } = n;
  const o = r === "fixed", s = be(e), i = a ? Ht(a.floating) : !1;
  if (e === s || i && o)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = De(1);
  const u = De(0), d = ye(e);
  if ((d || !d && !o) && (($e(e) !== "body" || ot(s)) && (l = Wt(e)), ye(e))) {
    const f = Ae(e);
    c = We(e), u.x = f.x + e.clientLeft, u.y = f.y + e.clientTop;
  }
  const p = s && !d && !o ? kn(s, l, !0) : De(0);
  return {
    width: t.width * c.x,
    height: t.height * c.y,
    x: t.x * c.x - l.scrollLeft * c.x + u.x + p.x,
    y: t.y * c.y - l.scrollTop * c.y + u.y + p.y
  };
}
function Uo(n) {
  return Array.from(n.getClientRects());
}
function qo(n) {
  const a = be(n), t = Wt(n), e = n.ownerDocument.body, r = Ie(a.scrollWidth, a.clientWidth, e.scrollWidth, e.clientWidth), o = Ie(a.scrollHeight, a.clientHeight, e.scrollHeight, e.clientHeight);
  let s = -t.scrollLeft + yr(n);
  const i = -t.scrollTop;
  return le(e).direction === "rtl" && (s += Ie(a.clientWidth, e.clientWidth) - r), {
    width: r,
    height: o,
    x: s,
    y: i
  };
}
function $o(n, a) {
  const t = oe(n), e = be(n), r = t.visualViewport;
  let o = e.clientWidth, s = e.clientHeight, i = 0, l = 0;
  if (r) {
    o = r.width, s = r.height;
    const c = vr();
    (!c || c && a === "fixed") && (i = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: o,
    height: s,
    x: i,
    y: l
  };
}
function jo(n, a) {
  const t = Ae(n, !0, a === "fixed"), e = t.top + n.clientTop, r = t.left + n.clientLeft, o = ye(n) ? We(n) : De(1), s = n.clientWidth * o.x, i = n.clientHeight * o.y, l = r * o.x, c = e * o.y;
  return {
    width: s,
    height: i,
    x: l,
    y: c
  };
}
function Or(n, a, t) {
  let e;
  if (a === "viewport")
    e = $o(n, t);
  else if (a === "document")
    e = qo(be(n));
  else if (te(a))
    e = jo(a, t);
  else {
    const r = _n(n);
    e = {
      x: a.x - r.x,
      y: a.y - r.y,
      width: a.width,
      height: a.height
    };
  }
  return Nt(e);
}
function xn(n, a) {
  const t = Ne(n);
  return t === a || !te(t) || Ve(t) ? !1 : le(t).position === "fixed" || xn(t, a);
}
function zo(n, a) {
  const t = a.get(n);
  if (t)
    return t;
  let e = rt(n, [], !1).filter((i) => te(i) && $e(i) !== "body"), r = null;
  const o = le(n).position === "fixed";
  let s = o ? Ne(n) : n;
  for (; te(s) && !Ve(s); ) {
    const i = le(s), l = mr(s);
    !l && i.position === "fixed" && (r = null), (o ? !l && !r : !l && i.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || ot(s) && !l && xn(n, s)) ? e = e.filter((u) => u !== s) : r = i, s = Ne(s);
  }
  return a.set(n, e), e;
}
function Xo(n) {
  let {
    element: a,
    boundary: t,
    rootBoundary: e,
    strategy: r
  } = n;
  const s = [...t === "clippingAncestors" ? Ht(a) ? [] : zo(a, this._c) : [].concat(t), e], i = s[0], l = s.reduce((c, u) => {
    const d = Or(a, u, r);
    return c.top = Ie(d.top, c.top), c.right = Ue(d.right, c.right), c.bottom = Ue(d.bottom, c.bottom), c.left = Ie(d.left, c.left), c;
  }, Or(a, i, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Go(n) {
  const {
    width: a,
    height: t
  } = bn(n);
  return {
    width: a,
    height: t
  };
}
function Zo(n, a, t) {
  const e = ye(a), r = be(a), o = t === "fixed", s = Ae(n, !0, o, a);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = De(0);
  if (e || !e && !o)
    if (($e(a) !== "body" || ot(r)) && (i = Wt(a)), e) {
      const p = Ae(a, !0, o, a);
      l.x = p.x + a.clientLeft, l.y = p.y + a.clientTop;
    } else r && (l.x = yr(r));
  const c = r && !e && !o ? kn(r, i) : De(0), u = s.left + i.scrollLeft - l.x - c.x, d = s.top + i.scrollTop - l.y - c.y;
  return {
    x: u,
    y: d,
    width: s.width,
    height: s.height
  };
}
function Ut(n) {
  return le(n).position === "static";
}
function Nr(n, a) {
  if (!ye(n) || le(n).position === "fixed")
    return null;
  if (a)
    return a(n);
  let t = n.offsetParent;
  return be(n) === t && (t = t.ownerDocument.body), t;
}
function Mn(n, a) {
  const t = oe(n);
  if (Ht(n))
    return t;
  if (!ye(n)) {
    let r = Ne(n);
    for (; r && !Ve(r); ) {
      if (te(r) && !Ut(r))
        return r;
      r = Ne(r);
    }
    return t;
  }
  let e = Nr(n, a);
  for (; e && Mo(e) && Ut(e); )
    e = Nr(e, a);
  return e && Ve(e) && Ut(e) && !mr(e) ? t : e || Co(n) || t;
}
const Jo = async function(n) {
  const a = this.getOffsetParent || Mn, t = this.getDimensions, e = await t(n.floating);
  return {
    reference: Zo(n.reference, await a(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: e.width,
      height: e.height
    }
  };
};
function es(n) {
  return le(n).direction === "rtl";
}
const ts = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Vo,
  getDocumentElement: be,
  getClippingRect: Xo,
  getOffsetParent: Mn,
  getElementRects: Jo,
  getClientRects: Uo,
  getDimensions: Go,
  getScale: We,
  isElement: te,
  isRTL: es
};
function rs(n, a) {
  let t = null, e;
  const r = be(n);
  function o() {
    var i;
    clearTimeout(e), (i = t) == null || i.disconnect(), t = null;
  }
  function s(i, l) {
    i === void 0 && (i = !1), l === void 0 && (l = 1), o();
    const {
      left: c,
      top: u,
      width: d,
      height: p
    } = n.getBoundingClientRect();
    if (i || a(), !d || !p)
      return;
    const f = dt(u), h = dt(r.clientWidth - (c + d)), v = dt(r.clientHeight - (u + p)), g = dt(c), M = {
      rootMargin: -f + "px " + -h + "px " + -v + "px " + -g + "px",
      threshold: Ie(0, Ue(1, l)) || 1
    };
    let k = !0;
    function E(S) {
      const O = S[0].intersectionRatio;
      if (O !== l) {
        if (!k)
          return s();
        O ? s(!1, O) : e = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      k = !1;
    }
    try {
      t = new IntersectionObserver(E, {
        ...M,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(E, M);
    }
    t.observe(n);
  }
  return s(!0), o;
}
function ns(n, a, t, e) {
  e === void 0 && (e = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: o = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = e, c = wr(n), u = r || o ? [...c ? rt(c) : [], ...rt(a)] : [];
  u.forEach((D) => {
    r && D.addEventListener("scroll", t, {
      passive: !0
    }), o && D.addEventListener("resize", t);
  });
  const d = c && i ? rs(c, t) : null;
  let p = -1, f = null;
  s && (f = new ResizeObserver((D) => {
    let [M] = D;
    M && M.target === c && f && (f.unobserve(a), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var k;
      (k = f) == null || k.observe(a);
    })), t();
  }), c && !l && f.observe(c), f.observe(a));
  let h, v = l ? Ae(n) : null;
  l && g();
  function g() {
    const D = Ae(n);
    v && (D.x !== v.x || D.y !== v.y || D.width !== v.width || D.height !== v.height) && t(), v = D, h = requestAnimationFrame(g);
  }
  return t(), () => {
    var D;
    u.forEach((M) => {
      r && M.removeEventListener("scroll", t), o && M.removeEventListener("resize", t);
    }), d == null || d(), (D = f) == null || D.disconnect(), f = null, l && cancelAnimationFrame(h);
  };
}
const as = Bo, os = Ho, Rr = Ao, ss = (n, a, t) => {
  const e = /* @__PURE__ */ new Map(), r = {
    platform: ts,
    ...t
  }, o = {
    ...r.platform,
    _c: e
  };
  return Lo(n, a, {
    ...r,
    platform: o
  });
};
var yt = typeof document < "u" ? tn : lr;
function Rt(n, a) {
  if (n === a)
    return !0;
  if (typeof n != typeof a)
    return !1;
  if (typeof n == "function" && n.toString() === a.toString())
    return !0;
  let t, e, r;
  if (n && a && typeof n == "object") {
    if (Array.isArray(n)) {
      if (t = n.length, t !== a.length) return !1;
      for (e = t; e-- !== 0; )
        if (!Rt(n[e], a[e]))
          return !1;
      return !0;
    }
    if (r = Object.keys(n), t = r.length, t !== Object.keys(a).length)
      return !1;
    for (e = t; e-- !== 0; )
      if (!{}.hasOwnProperty.call(a, r[e]))
        return !1;
    for (e = t; e-- !== 0; ) {
      const o = r[e];
      if (!(o === "_owner" && n.$$typeof) && !Rt(n[o], a[o]))
        return !1;
    }
    return !0;
  }
  return n !== n && a !== a;
}
function Cn(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Yr(n, a) {
  const t = Cn(n);
  return Math.round(a * t) / t;
}
function qt(n) {
  const a = P.useRef(n);
  return yt(() => {
    a.current = n;
  }), a;
}
function is(n) {
  n === void 0 && (n = {});
  const {
    placement: a = "bottom",
    strategy: t = "absolute",
    middleware: e = [],
    platform: r,
    elements: {
      reference: o,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: l,
    open: c
  } = n, [u, d] = P.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: a,
    middlewareData: {},
    isPositioned: !1
  }), [p, f] = P.useState(e);
  Rt(p, e) || f(e);
  const [h, v] = P.useState(null), [g, D] = P.useState(null), M = P.useCallback((N) => {
    N !== O.current && (O.current = N, v(N));
  }, []), k = P.useCallback((N) => {
    N !== y.current && (y.current = N, D(N));
  }, []), E = o || h, S = s || g, O = P.useRef(null), y = P.useRef(null), _ = P.useRef(u), C = l != null, L = qt(l), W = qt(r), A = qt(c), K = P.useCallback(() => {
    if (!O.current || !y.current)
      return;
    const N = {
      placement: a,
      strategy: t,
      middleware: p
    };
    W.current && (N.platform = W.current), ss(O.current, y.current, N).then((X) => {
      const ce = {
        ...X,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: A.current !== !1
      };
      V.current && !Rt(_.current, ce) && (_.current = ce, Gn.flushSync(() => {
        d(ce);
      }));
    });
  }, [p, a, t, W, A]);
  yt(() => {
    c === !1 && _.current.isPositioned && (_.current.isPositioned = !1, d((N) => ({
      ...N,
      isPositioned: !1
    })));
  }, [c]);
  const V = P.useRef(!1);
  yt(() => (V.current = !0, () => {
    V.current = !1;
  }), []), yt(() => {
    if (E && (O.current = E), S && (y.current = S), E && S) {
      if (L.current)
        return L.current(E, S, K);
      K();
    }
  }, [E, S, K, L, C]);
  const Q = P.useMemo(() => ({
    reference: O,
    floating: y,
    setReference: M,
    setFloating: k
  }), [M, k]), T = P.useMemo(() => ({
    reference: E,
    floating: S
  }), [E, S]), Y = P.useMemo(() => {
    const N = {
      position: t,
      left: 0,
      top: 0
    };
    if (!T.floating)
      return N;
    const X = Yr(T.floating, u.x), ce = Yr(T.floating, u.y);
    return i ? {
      ...N,
      transform: "translate(" + X + "px, " + ce + "px)",
      ...Cn(T.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: X,
      top: ce
    };
  }, [t, i, T.floating, u.x, u.y]);
  return P.useMemo(() => ({
    ...u,
    update: K,
    refs: Q,
    elements: T,
    floatingStyles: Y
  }), [u, K, Q, T, Y]);
}
const ls = (n) => {
  function a(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(t) {
      const {
        element: e,
        padding: r
      } = typeof n == "function" ? n(t) : n;
      return e && a(e) ? e.current != null ? Rr({
        element: e.current,
        padding: r
      }).fn(t) : {} : e ? Rr({
        element: e,
        padding: r
      }).fn(t) : {};
    }
  };
}, cs = (n, a) => ({
  ...as(n),
  options: [n, a]
}), us = (n, a) => ({
  ...os(n),
  options: [n, a]
}), ds = (n, a) => ({
  ...ls(n),
  options: [n, a]
}), Sn = {
  ...P
}, ps = Sn.useInsertionEffect, fs = ps || ((n) => n());
function hs(n) {
  const a = P.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return fs(() => {
    a.current = n;
  }), P.useCallback(function() {
    for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
      e[r] = arguments[r];
    return a.current == null ? void 0 : a.current(...e);
  }, []);
}
var Yt = typeof document < "u" ? tn : lr;
function sr() {
  return sr = Object.assign ? Object.assign.bind() : function(n) {
    for (var a = 1; a < arguments.length; a++) {
      var t = arguments[a];
      for (var e in t)
        Object.prototype.hasOwnProperty.call(t, e) && (n[e] = t[e]);
    }
    return n;
  }, sr.apply(this, arguments);
}
let Ir = !1, ms = 0;
const Lr = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + ms++
);
function vs() {
  const [n, a] = P.useState(() => Ir ? Lr() : void 0);
  return Yt(() => {
    n == null && a(Lr());
  }, []), P.useEffect(() => {
    Ir = !0;
  }, []), n;
}
const gs = Sn.useId, En = gs || vs;
let at;
process.env.NODE_ENV !== "production" && (at = /* @__PURE__ */ new Set());
function Ds() {
  for (var n, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const r = "Floating UI: " + t.join(" ");
  if (!((n = at) != null && n.has(r))) {
    var o;
    (o = at) == null || o.add(r), console.warn(r);
  }
}
function ws() {
  for (var n, a = arguments.length, t = new Array(a), e = 0; e < a; e++)
    t[e] = arguments[e];
  const r = "Floating UI: " + t.join(" ");
  if (!((n = at) != null && n.has(r))) {
    var o;
    (o = at) == null || o.add(r), console.error(r);
  }
}
const ys = /* @__PURE__ */ P.forwardRef(function(a, t) {
  const {
    context: {
      placement: e,
      elements: {
        floating: r
      },
      middlewareData: {
        arrow: o,
        shift: s
      }
    },
    width: i = 14,
    height: l = 7,
    tipRadius: c = 0,
    strokeWidth: u = 0,
    staticOffset: d,
    stroke: p,
    d: f,
    style: {
      transform: h,
      ...v
    } = {},
    ...g
  } = a;
  process.env.NODE_ENV !== "production" && (t || Ds("The `ref` prop is required for `FloatingArrow`."));
  const D = En(), [M, k] = P.useState(!1);
  if (Yt(() => {
    if (!r) return;
    le(r).direction === "rtl" && k(!0);
  }, [r]), !r)
    return null;
  const [E, S] = e.split("-"), O = E === "top" || E === "bottom";
  let y = d;
  (O && s != null && s.x || !O && s != null && s.y) && (y = null);
  const _ = u * 2, C = _ / 2, L = i / 2 * (c / -8 + 1), W = l / 2 * c / 4, A = !!f, K = y && S === "end" ? "bottom" : "top";
  let V = y && S === "end" ? "right" : "left";
  y && M && (V = S === "end" ? "left" : "right");
  const Q = (o == null ? void 0 : o.x) != null ? y || o.x : "", T = (o == null ? void 0 : o.y) != null ? y || o.y : "", Y = f || "M0,0" + (" H" + i) + (" L" + (i - L) + "," + (l - W)) + (" Q" + i / 2 + "," + l + " " + L + "," + (l - W)) + " Z", N = {
    top: A ? "rotate(180deg)" : "",
    left: A ? "rotate(90deg)" : "rotate(-90deg)",
    bottom: A ? "" : "rotate(180deg)",
    right: A ? "rotate(-90deg)" : "rotate(90deg)"
  }[E];
  return /* @__PURE__ */ P.createElement("svg", sr({}, g, {
    "aria-hidden": !0,
    ref: t,
    width: A ? i : i + _,
    height: i,
    viewBox: "0 0 " + i + " " + (l > i ? l : i),
    style: {
      position: "absolute",
      pointerEvents: "none",
      [V]: Q,
      [K]: T,
      [E]: O || A ? "100%" : "calc(100% - " + _ / 2 + "px)",
      transform: [N, h].filter((X) => !!X).join(" "),
      ...v
    }
  }), _ > 0 && /* @__PURE__ */ P.createElement("path", {
    clipPath: "url(#" + D + ")",
    fill: "none",
    stroke: p,
    strokeWidth: _ + (f ? 0 : 1),
    d: Y
  }), /* @__PURE__ */ P.createElement("path", {
    stroke: _ && !f ? g.fill : "none",
    d: Y
  }), /* @__PURE__ */ P.createElement("clipPath", {
    id: D
  }, /* @__PURE__ */ P.createElement("rect", {
    x: -C,
    y: C * (A ? -1 : 1),
    width: i + _,
    height: i
  })));
});
function bs() {
  const n = /* @__PURE__ */ new Map();
  return {
    emit(a, t) {
      var e;
      (e = n.get(a)) == null || e.forEach((r) => r(t));
    },
    on(a, t) {
      n.set(a, [...n.get(a) || [], t]);
    },
    off(a, t) {
      var e;
      n.set(a, ((e = n.get(a)) == null ? void 0 : e.filter((r) => r !== t)) || []);
    }
  };
}
const _s = /* @__PURE__ */ P.createContext(null), ks = /* @__PURE__ */ P.createContext(null), xs = () => {
  var n;
  return ((n = P.useContext(_s)) == null ? void 0 : n.id) || null;
}, Ms = () => P.useContext(ks);
function Cs(n) {
  const {
    open: a = !1,
    onOpenChange: t,
    elements: e
  } = n, r = En(), o = P.useRef({}), [s] = P.useState(() => bs()), i = xs() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = e.reference;
    f && !te(f) && ws("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, c] = P.useState(e.reference), u = hs((f, h, v) => {
    o.current.openEvent = f ? h : void 0, s.emit("openchange", {
      open: f,
      event: h,
      reason: v,
      nested: i
    }), t == null || t(f, h, v);
  }), d = P.useMemo(() => ({
    setPositionReference: c
  }), []), p = P.useMemo(() => ({
    reference: l || e.reference || null,
    floating: e.floating || null,
    domReference: e.reference
  }), [l, e.reference, e.floating]);
  return P.useMemo(() => ({
    dataRef: o,
    open: a,
    onOpenChange: u,
    elements: p,
    events: s,
    floatingId: r,
    refs: d
  }), [a, u, p, s, r, d]);
}
function Ss(n) {
  n === void 0 && (n = {});
  const {
    nodeId: a
  } = n, t = Cs({
    ...n,
    elements: {
      reference: null,
      floating: null,
      ...n.elements
    }
  }), e = n.rootContext || t, r = e.elements, [o, s] = P.useState(null), [i, l] = P.useState(null), u = (r == null ? void 0 : r.domReference) || o, d = P.useRef(null), p = Ms();
  Yt(() => {
    u && (d.current = u);
  }, [u]);
  const f = is({
    ...n,
    elements: {
      ...r,
      ...i && {
        reference: i
      }
    }
  }), h = P.useCallback((k) => {
    const E = te(k) ? {
      getBoundingClientRect: () => k.getBoundingClientRect(),
      contextElement: k
    } : k;
    l(E), f.refs.setReference(E);
  }, [f.refs]), v = P.useCallback((k) => {
    (te(k) || k === null) && (d.current = k, s(k)), (te(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    k !== null && !te(k)) && f.refs.setReference(k);
  }, [f.refs]), g = P.useMemo(() => ({
    ...f.refs,
    setReference: v,
    setPositionReference: h,
    domReference: d
  }), [f.refs, v, h]), D = P.useMemo(() => ({
    ...f.elements,
    domReference: u
  }), [f.elements, u]), M = P.useMemo(() => ({
    ...f,
    ...e,
    refs: g,
    elements: D,
    nodeId: a
  }), [f, g, D, a, e]);
  return Yt(() => {
    e.dataRef.current.floatingContext = M;
    const k = p == null ? void 0 : p.nodesRef.current.find((E) => E.id === a);
    k && (k.context = M);
  }), P.useMemo(() => ({
    ...f,
    context: M,
    refs: g,
    elements: D
  }), [f, g, D, M]);
}
/*!
  react-datepicker v7.5.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/
var ir = function(a, t) {
  return ir = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function(e, r) {
    e.__proto__ = r;
  } || function(e, r) {
    for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
  }, ir(a, t);
};
function ee(n, a) {
  if (typeof a != "function" && a !== null) throw new TypeError("Class extends value " + String(a) + " is not a constructor or null");
  ir(n, a);
  function t() {
    this.constructor = n;
  }
  n.prototype = a === null ? Object.create(a) : (t.prototype = a.prototype, new t());
}
var F = function() {
  return F = Object.assign || function(t) {
    for (var e, r = 1, o = arguments.length; r < o; r++) {
      e = arguments[r];
      for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && (t[s] = e[s]);
    }
    return t;
  }, F.apply(this, arguments);
};
function me(n, a, t) {
  if (t || arguments.length === 2) for (var e = 0, r = a.length, o; e < r; e++)
    (o || !(e in a)) && (o || (o = Array.prototype.slice.call(a, 0, e)), o[e] = a[e]);
  return n.concat(o || Array.prototype.slice.call(a));
}
var Es = function(n) {
  var a = n.showTimeSelectOnly, t = a === void 0 ? !1 : a, e = n.showTime, r = e === void 0 ? !1 : e, o = n.className, s = n.children, i = t ? "Choose Time" : "Choose Date".concat(r ? " and Time" : "");
  return m.createElement("div", { className: o, role: "dialog", "aria-label": i, "aria-modal": "true" }, s);
}, Ps = function(n, a) {
  var t = kt(null), e = kt(n);
  e.current = n;
  var r = Bn(function(o) {
    var s;
    t.current && !t.current.contains(o.target) && (a && o.target instanceof HTMLElement && o.target.classList.contains(a) || (s = e.current) === null || s === void 0 || s.call(e, o));
  }, [a]);
  return lr(function() {
    return document.addEventListener("mousedown", r), function() {
      document.removeEventListener("mousedown", r);
    };
  }, [r]), t;
}, Qt = function(n) {
  var a = n.children, t = n.onClickOutside, e = n.className, r = n.containerRef, o = n.style, s = n.ignoreClass, i = Ps(t, s);
  return m.createElement("div", { className: e, style: o, ref: function(l) {
    i.current = l, r && (r.current = l);
  } }, a);
}, w;
(function(n) {
  n.ArrowUp = "ArrowUp", n.ArrowDown = "ArrowDown", n.ArrowLeft = "ArrowLeft", n.ArrowRight = "ArrowRight", n.PageUp = "PageUp", n.PageDown = "PageDown", n.Home = "Home", n.End = "End", n.Enter = "Enter", n.Space = " ", n.Tab = "Tab", n.Escape = "Escape", n.Backspace = "Backspace", n.X = "x";
})(w || (w = {}));
function Pn() {
  var n = typeof window < "u" ? window : globalThis;
  return n;
}
var it = 12, Ts = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
function B(n) {
  if (n == null)
    return /* @__PURE__ */ new Date();
  var a = typeof n == "string" ? io(n) : x(n);
  return _e(a) ? a : /* @__PURE__ */ new Date();
}
function $t(n, a, t, e, r) {
  var o, s = null, i = Le(t) || Le(Ze()), l = !0;
  if (Array.isArray(a))
    return a.forEach(function(u) {
      var d = Kt(n, u, /* @__PURE__ */ new Date(), {
        locale: i,
        useAdditionalWeekYearTokens: !0,
        useAdditionalDayOfYearTokens: !0
      });
      e && (l = _e(d, r) && n === U(d, u, t)), _e(d, r) && l && (s = d);
    }), s;
  if (s = Kt(n, a, /* @__PURE__ */ new Date(), {
    locale: i,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  }), e)
    l = _e(s) && n === U(s, a, t);
  else if (!_e(s)) {
    var c = ((o = a.match(Ts)) !== null && o !== void 0 ? o : []).map(function(u) {
      var d = u[0];
      if (d === "p" || d === "P") {
        var p = Zt[d];
        return i ? p(u, i.formatLong) : d;
      }
      return u;
    }).join("");
    n.length > 0 && (s = Kt(n, c.slice(0, n.length), /* @__PURE__ */ new Date(), {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    })), _e(s) || (s = new Date(n));
  }
  return _e(s) && l ? s : null;
}
function _e(n, a) {
  return Jt(n) && !Fe(n, a ?? /* @__PURE__ */ new Date("1/1/1800"));
}
function U(n, a, t) {
  if (t === "en")
    return er(n, a, {
      useAdditionalWeekYearTokens: !0,
      useAdditionalDayOfYearTokens: !0
    });
  var e = t ? Le(t) : void 0;
  return t && !e && console.warn('A locale object was not found for the provided string ["'.concat(t, '"].')), !e && Ze() && Le(Ze()) && (e = Le(Ze())), er(n, a, {
    locale: e,
    useAdditionalWeekYearTokens: !0,
    useAdditionalDayOfYearTokens: !0
  });
}
function se(n, a) {
  var t = a.dateFormat, e = a.locale, r = Array.isArray(t) && t.length > 0 ? t[0] : t;
  return n && U(n, r, e) || "";
}
function Os(n, a, t) {
  if (!n)
    return "";
  var e = se(n, t), r = a ? se(a, t) : "";
  return "".concat(e, " - ").concat(r);
}
function Ns(n, a) {
  if (!(n != null && n.length))
    return "";
  var t = n[0] ? se(n[0], a) : "";
  if (n.length === 1)
    return t;
  if (n.length === 2 && n[1]) {
    var e = se(n[1], a);
    return "".concat(t, ", ").concat(e);
  }
  var r = n.length - 1;
  return "".concat(t, " (+").concat(r, ")");
}
function jt(n, a) {
  var t = a.hour, e = t === void 0 ? 0 : t, r = a.minute, o = r === void 0 ? 0 : r, s = a.second, i = s === void 0 ? 0 : s;
  return gt(Dt(wt(n, i), o), e);
}
function Rs(n) {
  return an(n);
}
function Ys(n, a) {
  return U(n, "ddd", a);
}
function bt(n) {
  return Je(n);
}
function Ee(n, a, t) {
  var e = Le(a || Ze());
  return xt(n, {
    locale: e,
    weekStartsOn: t
  });
}
function Me(n) {
  return cn(n);
}
function Xe(n) {
  return ur(n);
}
function Fr(n) {
  return rr(n);
}
function Ar() {
  return Je(B());
}
function Hr(n) {
  return sn(n);
}
function Is(n) {
  return aa(n);
}
function Ls(n) {
  return ln(n);
}
function pe(n, a) {
  return n && a ? so(n, a) : !n && !a;
}
function re(n, a) {
  return n && a ? ao(n, a) : !n && !a;
}
function It(n, a) {
  return n && a ? oo(n, a) : !n && !a;
}
function I(n, a) {
  return n && a ? ra(n, a) : !n && !a;
}
function Re(n, a) {
  return n && a ? ca(n, a) : !n && !a;
}
function Ge(n, a, t) {
  var e, r = Je(a), o = sn(t);
  try {
    e = tt(n, { start: r, end: o });
  } catch {
    e = !1;
  }
  return e;
}
function Ze() {
  var n = Pn();
  return n.__localeId__;
}
function Le(n) {
  if (typeof n == "string") {
    var a = Pn();
    return a.__localeData__ ? a.__localeData__[n] : void 0;
  } else
    return n;
}
function Fs(n, a, t) {
  return a(U(n, "EEEE", t));
}
function As(n, a) {
  return U(n, "EEEEEE", a);
}
function Hs(n, a) {
  return U(n, "EEE", a);
}
function br(n, a) {
  return U(ae(B(), n), "LLLL", a);
}
function Tn(n, a) {
  return U(ae(B(), n), "LLL", a);
}
function Ws(n, a) {
  return U(He(B(), n), "QQQ", a);
}
function ie(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.excludeDateIntervals, i = t.includeDates, l = t.includeDateIntervals, c = t.filterDate;
  return lt(n, { minDate: e, maxDate: r }) || o && o.some(function(u) {
    return u instanceof Date ? I(n, u) : I(n, u.date);
  }) || s && s.some(function(u) {
    var d = u.start, p = u.end;
    return tt(n, { start: d, end: p });
  }) || i && !i.some(function(u) {
    return I(n, u);
  }) || l && !l.some(function(u) {
    var d = u.start, p = u.end;
    return tt(n, { start: d, end: p });
  }) || c && !c(B(n)) || !1;
}
function _r(n, a) {
  var t = a === void 0 ? {} : a, e = t.excludeDates, r = t.excludeDateIntervals;
  return r && r.length > 0 ? r.some(function(o) {
    var s = o.start, i = o.end;
    return tt(n, { start: s, end: i });
  }) : e && e.some(function(o) {
    var s;
    return o instanceof Date ? I(n, o) : I(n, (s = o.date) !== null && s !== void 0 ? s : /* @__PURE__ */ new Date());
  }) || !1;
}
function On(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return lt(n, {
    minDate: e ? cn(e) : void 0,
    maxDate: r ? ln(r) : void 0
  }) || (o == null ? void 0 : o.some(function(l) {
    return re(n, l instanceof Date ? l : l.date);
  })) || s && !s.some(function(l) {
    return re(n, l);
  }) || i && !i(B(n)) || !1;
}
function pt(n, a, t, e) {
  var r = R(n), o = ne(n), s = R(a), i = ne(a), l = R(e);
  return r === s && r === l ? o <= t && t <= i : r < s ? l === r && o <= t || l === s && i >= t || l < s && l > r : !1;
}
function Bs(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates;
  return lt(n, { minDate: e, maxDate: r }) || o && o.some(function(i) {
    return re(i instanceof Date ? i : i.date, n);
  }) || s && !s.some(function(i) {
    return re(i, n);
  }) || !1;
}
function ft(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate;
  return lt(n, { minDate: e, maxDate: r }) || (o == null ? void 0 : o.some(function(l) {
    return It(n, l instanceof Date ? l : l.date);
  })) || s && !s.some(function(l) {
    return It(n, l);
  }) || i && !i(B(n)) || !1;
}
function ht(n, a, t) {
  if (!a || !t || !Jt(a) || !Jt(t))
    return !1;
  var e = R(a), r = R(t);
  return e <= n && r >= n;
}
function _t(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.maxDate, o = t.excludeDates, s = t.includeDates, i = t.filterDate, l = new Date(n, 0, 1);
  return lt(l, {
    minDate: e ? ur(e) : void 0,
    maxDate: r ? un(r) : void 0
  }) || (o == null ? void 0 : o.some(function(c) {
    return pe(l, c instanceof Date ? c : c.date);
  })) || s && !s.some(function(c) {
    return pe(l, c);
  }) || i && !i(B(l)) || !1;
}
function mt(n, a, t, e) {
  var r = R(n), o = Ye(n), s = R(a), i = Ye(a), l = R(e);
  return r === s && r === l ? o <= t && t <= i : r < s ? l === r && o <= t || l === s && i >= t || l < s && l > r : !1;
}
function lt(n, a) {
  var t, e = a === void 0 ? {} : a, r = e.minDate, o = e.maxDate;
  return (t = r && et(n, r) < 0 || o && et(n, o) > 0) !== null && t !== void 0 ? t : !1;
}
function Wr(n, a) {
  return a.some(function(t) {
    return ve(t) === ve(n) && ge(t) === ge(n) && xe(t) === xe(n);
  });
}
function Br(n, a) {
  var t = a === void 0 ? {} : a, e = t.excludeTimes, r = t.includeTimes, o = t.filterTime;
  return e && Wr(n, e) || r && !Wr(n, r) || o && !o(n) || !1;
}
function Qr(n, a) {
  var t = a.minTime, e = a.maxTime;
  if (!t || !e)
    throw new Error("Both minTime and maxTime props required");
  var r = B();
  r = gt(r, ve(n)), r = Dt(r, ge(n)), r = wt(r, xe(n));
  var o = B();
  o = gt(o, ve(t)), o = Dt(o, ge(t)), o = wt(o, xe(t));
  var s = B();
  s = gt(s, ve(e)), s = Dt(s, ge(e)), s = wt(s, xe(e));
  var i;
  try {
    i = !tt(r, { start: o, end: s });
  } catch {
    i = !1;
  }
  return i;
}
function Kr(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = Qe(n, 1);
  return e && Ct(e, o) > 0 || r && r.every(function(s) {
    return Ct(s, o) > 0;
  }) || !1;
}
function Vr(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = we(n, 1);
  return e && Ct(o, e) > 0 || r && r.every(function(s) {
    return Ct(o, s) > 0;
  }) || !1;
}
function Qs(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = ur(n), s = vn(o, 1);
  return e && St(e, s) > 0 || r && r.every(function(i) {
    return St(i, s) > 0;
  }) || !1;
}
function Ks(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = un(n), s = pr(o, 1);
  return e && St(s, e) > 0 || r && r.every(function(i) {
    return St(s, i) > 0;
  }) || !1;
}
function Ur(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.includeDates, o = Ke(n, 1);
  return e && Et(e, o) > 0 || r && r.every(function(s) {
    return Et(s, o) > 0;
  }) || !1;
}
function Vs(n, a) {
  var t = a === void 0 ? {} : a, e = t.minDate, r = t.yearItemNumber, o = r === void 0 ? it : r, s = Xe(Ke(n, o)), i = Ce(s, o).endPeriod, l = e && R(e);
  return l && l > i || !1;
}
function qr(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.includeDates, o = ke(n, 1);
  return e && Et(o, e) > 0 || r && r.every(function(s) {
    return Et(o, s) > 0;
  }) || !1;
}
function Us(n, a) {
  var t = a === void 0 ? {} : a, e = t.maxDate, r = t.yearItemNumber, o = r === void 0 ? it : r, s = ke(n, o), i = Ce(s, o).startPeriod, l = e && R(e);
  return l && l < i || !1;
}
function Nn(n) {
  var a = n.minDate, t = n.includeDates;
  if (t && a) {
    var e = t.filter(function(r) {
      return et(r, a) >= 0;
    });
    return Mr(e);
  } else return t ? Mr(t) : a;
}
function Rn(n) {
  var a = n.maxDate, t = n.includeDates;
  if (t && a) {
    var e = t.filter(function(r) {
      return et(r, a) <= 0;
    });
    return xr(e);
  } else return t ? xr(t) : a;
}
function $r(n, a) {
  var t;
  n === void 0 && (n = []), a === void 0 && (a = "react-datepicker__day--highlighted");
  for (var e = /* @__PURE__ */ new Map(), r = 0, o = n.length; r < o; r++) {
    var s = n[r];
    if (Se(s)) {
      var i = U(s, "MM.dd.yyyy"), l = e.get(i) || [];
      l.includes(a) || (l.push(a), e.set(i, l));
    } else if (typeof s == "object") {
      var c = Object.keys(s), u = (t = c[0]) !== null && t !== void 0 ? t : "", d = s[u];
      if (typeof u == "string" && Array.isArray(d))
        for (var p = 0, f = d.length; p < f; p++) {
          var h = d[p];
          if (h) {
            var i = U(h, "MM.dd.yyyy"), l = e.get(i) || [];
            l.includes(u) || (l.push(u), e.set(i, l));
          }
        }
    }
  }
  return e;
}
function qs(n, a) {
  return n.length !== a.length ? !1 : n.every(function(t, e) {
    return t === a[e];
  });
}
function $s(n, a) {
  n === void 0 && (n = []), a === void 0 && (a = "react-datepicker__day--holidays");
  var t = /* @__PURE__ */ new Map();
  return n.forEach(function(e) {
    var r = e.date, o = e.holidayName;
    if (Se(r)) {
      var s = U(r, "MM.dd.yyyy"), i = t.get(s) || {
        className: "",
        holidayNames: []
      };
      if (!("className" in i && i.className === a && qs(i.holidayNames, [o]))) {
        i.className = a;
        var l = i.holidayNames;
        i.holidayNames = l ? me(me([], l, !0), [o], !1) : [o], t.set(s, i);
      }
    }
  }), t;
}
function js(n, a, t, e, r) {
  for (var o = r.length, s = [], i = 0; i < o; i++) {
    var l = n, c = r[i];
    c && (l = ea(l, ve(c)), l = tr(l, ge(c)), l = ta(l, xe(c)));
    var u = tr(n, (t + 1) * e);
    Oe(l, a) && Fe(l, u) && c != null && s.push(c);
  }
  return s;
}
function jr(n) {
  return n < 10 ? "0".concat(n) : "".concat(n);
}
function Ce(n, a) {
  a === void 0 && (a = it);
  var t = Math.ceil(R(n) / a) * a, e = t - (a - 1);
  return { startPeriod: e, endPeriod: t };
}
function zs(n) {
  var a = new Date(n.getFullYear(), n.getMonth(), n.getDate()), t = new Date(n.getFullYear(), n.getMonth(), n.getDate(), 24);
  return Math.round((+t - +a) / 36e5);
}
function zr(n) {
  var a = n.getSeconds(), t = n.getMilliseconds();
  return x(n.getTime() - a * 1e3 - t);
}
function Xs(n, a) {
  return zr(n).getTime() === zr(a).getTime();
}
function Xr(n) {
  if (!Se(n))
    throw new Error("Invalid date");
  var a = new Date(n);
  return a.setHours(0, 0, 0, 0), a;
}
function Gr(n, a) {
  if (!Se(n) || !Se(a))
    throw new Error("Invalid date received");
  var t = Xr(n), e = Xr(a);
  return Fe(t, e);
}
function Yn(n) {
  return n.key === w.Space;
}
var Gs = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.inputRef = m.createRef(), e.onTimeChange = function(r) {
        var o, s;
        e.setState({ time: r });
        var i = e.props.date, l = i instanceof Date && !isNaN(+i), c = l ? i : /* @__PURE__ */ new Date();
        if (r != null && r.includes(":")) {
          var u = r.split(":"), d = u[0], p = u[1];
          c.setHours(Number(d)), c.setMinutes(Number(p));
        }
        (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, c);
      }, e.renderTimeInput = function() {
        var r = e.state.time, o = e.props, s = o.date, i = o.timeString, l = o.customTimeInput;
        return l ? rn(l, {
          date: s,
          value: r,
          onChange: e.onTimeChange
        }) : m.createElement("input", { type: "time", className: "react-datepicker-time__input", placeholder: "Time", name: "time-input", ref: e.inputRef, onClick: function() {
          var c;
          (c = e.inputRef.current) === null || c === void 0 || c.focus();
        }, required: !0, value: r, onChange: function(c) {
          e.onTimeChange(c.target.value || i);
        } });
      }, e.state = {
        time: e.props.timeString
      }, e;
    }
    return a.getDerivedStateFromProps = function(t, e) {
      return t.timeString !== e.time ? {
        time: t.timeString
      } : null;
    }, a.prototype.render = function() {
      return m.createElement(
        "div",
        { className: "react-datepicker__input-time-container" },
        m.createElement("div", { className: "react-datepicker-time__caption" }, this.props.timeInputLabel),
        m.createElement(
          "div",
          { className: "react-datepicker-time__input-container" },
          m.createElement("div", { className: "react-datepicker-time__input" }, this.renderTimeInput())
        )
      );
    }, a;
  }(J)
), Zs = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.dayEl = Pe(), t.handleClick = function(e) {
        !t.isDisabled() && t.props.onClick && t.props.onClick(e);
      }, t.handleMouseEnter = function(e) {
        !t.isDisabled() && t.props.onMouseEnter && t.props.onMouseEnter(e);
      }, t.handleOnKeyDown = function(e) {
        var r, o, s = e.key;
        s === w.Space && (e.preventDefault(), e.key = w.Enter), (o = (r = t.props).handleOnKeyDown) === null || o === void 0 || o.call(r, e);
      }, t.isSameDay = function(e) {
        return I(t.props.day, e);
      }, t.isKeyboardSelected = function() {
        var e;
        if (t.props.disabledKeyboardNavigation)
          return !1;
        var r = t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(s) {
          return t.isSameDayOrWeek(s);
        }) : t.isSameDayOrWeek(t.props.selected), o = t.props.preSelection && t.isDisabled(t.props.preSelection);
        return !r && t.isSameDayOrWeek(t.props.preSelection) && !o;
      }, t.isDisabled = function(e) {
        return e === void 0 && (e = t.props.day), ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function() {
        return _r(t.props.day, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.isStartOfWeek = function() {
        return I(t.props.day, Ee(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameWeek = function(e) {
        return t.props.showWeekPicker && I(e, Ee(t.props.day, t.props.locale, t.props.calendarStartDay));
      }, t.isSameDayOrWeek = function(e) {
        return t.isSameDay(e) || t.isSameWeek(e);
      }, t.getHighLightedClass = function() {
        var e = t.props, r = e.day, o = e.highlightDates;
        if (!o)
          return !1;
        var s = U(r, "MM.dd.yyyy");
        return o.get(s);
      }, t.getHolidaysClass = function() {
        var e, r = t.props, o = r.day, s = r.holidays;
        if (!s)
          return [void 0];
        var i = U(o, "MM.dd.yyyy");
        return s.has(i) ? [(e = s.get(i)) === null || e === void 0 ? void 0 : e.className] : [void 0];
      }, t.isInRange = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : Ge(r, o, s);
      }, t.isInSelectingRange = function() {
        var e, r = t.props, o = r.day, s = r.selectsStart, i = r.selectsEnd, l = r.selectsRange, c = r.selectsDisabledDaysInRange, u = r.startDate, d = r.endDate, p = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return !(s || i || l) || !p || !c && t.isDisabled() ? !1 : s && d && (Fe(p, d) || Re(p, d)) ? Ge(o, p, d) : i && u && (Oe(p, u) || Re(p, u)) || l && u && !d && (Oe(p, u) || Re(p, u)) ? Ge(o, u, p) : !1;
      }, t.isSelectingRangeStart = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var r = t.props, o = r.day, s = r.startDate, i = r.selectsStart, l = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i ? I(o, l) : I(o, s);
      }, t.isSelectingRangeEnd = function() {
        var e;
        if (!t.isInSelectingRange())
          return !1;
        var r = t.props, o = r.day, s = r.endDate, i = r.selectsEnd, l = r.selectsRange, c = (e = t.props.selectingDate) !== null && e !== void 0 ? e : t.props.preSelection;
        return i || l ? I(o, c) : I(o, s);
      }, t.isRangeStart = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : I(o, r);
      }, t.isRangeEnd = function() {
        var e = t.props, r = e.day, o = e.startDate, s = e.endDate;
        return !o || !s ? !1 : I(s, r);
      }, t.isWeekend = function() {
        var e = oa(t.props.day);
        return e === 0 || e === 6;
      }, t.isAfterMonth = function() {
        return t.props.month !== void 0 && (t.props.month + 1) % 12 === ne(t.props.day);
      }, t.isBeforeMonth = function() {
        return t.props.month !== void 0 && (ne(t.props.day) + 1) % 12 === t.props.month;
      }, t.isCurrentDay = function() {
        return t.isSameDay(B());
      }, t.isSelected = function() {
        var e;
        return t.props.selectsMultiple ? (e = t.props.selectedDates) === null || e === void 0 ? void 0 : e.some(function(r) {
          return t.isSameDayOrWeek(r);
        }) : t.isSameDayOrWeek(t.props.selected);
      }, t.getClassNames = function(e) {
        var r = t.props.dayClassName ? t.props.dayClassName(e) : void 0;
        return Z("react-datepicker__day", r, "react-datepicker__day--" + Ys(t.props.day), {
          "react-datepicker__day--disabled": t.isDisabled(),
          "react-datepicker__day--excluded": t.isExcluded(),
          "react-datepicker__day--selected": t.isSelected(),
          "react-datepicker__day--keyboard-selected": t.isKeyboardSelected(),
          "react-datepicker__day--range-start": t.isRangeStart(),
          "react-datepicker__day--range-end": t.isRangeEnd(),
          "react-datepicker__day--in-range": t.isInRange(),
          "react-datepicker__day--in-selecting-range": t.isInSelectingRange(),
          "react-datepicker__day--selecting-range-start": t.isSelectingRangeStart(),
          "react-datepicker__day--selecting-range-end": t.isSelectingRangeEnd(),
          "react-datepicker__day--today": t.isCurrentDay(),
          "react-datepicker__day--weekend": t.isWeekend(),
          "react-datepicker__day--outside-month": t.isAfterMonth() || t.isBeforeMonth()
        }, t.getHighLightedClass(), t.getHolidaysClass());
      }, t.getAriaLabel = function() {
        var e = t.props, r = e.day, o = e.ariaLabelPrefixWhenEnabled, s = o === void 0 ? "Choose" : o, i = e.ariaLabelPrefixWhenDisabled, l = i === void 0 ? "Not available" : i, c = t.isDisabled() || t.isExcluded() ? l : s;
        return "".concat(c, " ").concat(U(r, "PPPP", t.props.locale));
      }, t.getTitle = function() {
        var e = t.props, r = e.day, o = e.holidays, s = o === void 0 ? /* @__PURE__ */ new Map() : o, i = e.excludeDates, l = U(r, "MM.dd.yyyy"), c = [];
        return s.has(l) && c.push.apply(c, s.get(l).holidayNames), t.isExcluded() && c.push(i == null ? void 0 : i.filter(function(u) {
          return u instanceof Date ? I(u, r) : I(u == null ? void 0 : u.date, r);
        }).map(function(u) {
          if (!(u instanceof Date))
            return u == null ? void 0 : u.message;
        })), c.join(", ");
      }, t.getTabIndex = function() {
        var e = t.props.selected, r = t.props.preSelection, o = !(t.props.showWeekPicker && (t.props.showWeekNumber || !t.isStartOfWeek())) && (t.isKeyboardSelected() || t.isSameDay(e) && I(r, e)) ? 0 : -1;
        return o;
      }, t.handleFocusDay = function() {
        var e;
        t.shouldFocusDay() && ((e = t.dayEl.current) === null || e === void 0 || e.focus({ preventScroll: !0 }));
      }, t.renderDayContents = function() {
        return t.props.monthShowsDuplicateDaysEnd && t.isAfterMonth() || t.props.monthShowsDuplicateDaysStart && t.isBeforeMonth() ? null : t.props.renderDayContents ? t.props.renderDayContents(Sr(t.props.day), t.props.day) : Sr(t.props.day);
      }, t.render = function() {
        return (
          // TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
          m.createElement(
            "div",
            { ref: t.dayEl, className: t.getClassNames(t.props.day), onKeyDown: t.handleOnKeyDown, onClick: t.handleClick, onMouseEnter: t.props.usePointerEvent ? void 0 : t.handleMouseEnter, onPointerEnter: t.props.usePointerEvent ? t.handleMouseEnter : void 0, tabIndex: t.getTabIndex(), "aria-label": t.getAriaLabel(), role: "option", title: t.getTitle(), "aria-disabled": t.isDisabled(), "aria-current": t.isCurrentDay() ? "date" : void 0, "aria-selected": t.isSelected() || t.isInRange() },
            t.renderDayContents(),
            t.getTitle() !== "" && m.createElement("span", { className: "overlay" }, t.getTitle())
          )
        );
      }, t;
    }
    return a.prototype.componentDidMount = function() {
      this.handleFocusDay();
    }, a.prototype.componentDidUpdate = function() {
      this.handleFocusDay();
    }, a.prototype.shouldFocusDay = function() {
      var t = !1;
      return this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (t = !0), this.props.inline && !this.props.shouldFocusDayInline && (t = !1), this.isDayActiveElement() && (t = !0), this.isDuplicateDay() && (t = !1)), t;
    }, a.prototype.isDayActiveElement = function() {
      var t, e, r;
      return ((e = (t = this.props.containerRef) === null || t === void 0 ? void 0 : t.current) === null || e === void 0 ? void 0 : e.contains(document.activeElement)) && ((r = document.activeElement) === null || r === void 0 ? void 0 : r.classList.contains("react-datepicker__day"));
    }, a.prototype.isDuplicateDay = function() {
      return (
        //day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth()
      );
    }, a;
  }(J)
), Js = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.weekNumberEl = Pe(), t.handleClick = function(e) {
        t.props.onClick && t.props.onClick(e);
      }, t.handleOnKeyDown = function(e) {
        var r, o, s = e.key;
        s === w.Space && (e.preventDefault(), e.key = w.Enter), (o = (r = t.props).handleOnKeyDown) === null || o === void 0 || o.call(r, e);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !I(t.props.date, t.props.selected) && I(t.props.date, t.props.preSelection);
      }, t.getTabIndex = function() {
        return t.props.showWeekPicker && t.props.showWeekNumber && (t.isKeyboardSelected() || I(t.props.date, t.props.selected) && I(t.props.preSelection, t.props.selected)) ? 0 : -1;
      }, t.handleFocusWeekNumber = function(e) {
        var r = !1;
        t.getTabIndex() === 0 && !(e != null && e.isInputFocused) && I(t.props.date, t.props.preSelection) && ((!document.activeElement || document.activeElement === document.body) && (r = !0), t.props.inline && !t.props.shouldFocusDayInline && (r = !1), t.props.containerRef && t.props.containerRef.current && t.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && t.weekNumberEl.current && t.weekNumberEl.current.focus({ preventScroll: !0 });
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          ariaLabelPrefix: "week "
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.handleFocusWeekNumber();
    }, a.prototype.componentDidUpdate = function(t) {
      this.handleFocusWeekNumber(t);
    }, a.prototype.render = function() {
      var t = this.props, e = t.weekNumber, r = t.ariaLabelPrefix, o = r === void 0 ? a.defaultProps.ariaLabelPrefix : r, s = t.onClick, i = {
        "react-datepicker__week-number": !0,
        "react-datepicker__week-number--clickable": !!s,
        "react-datepicker__week-number--selected": !!s && I(this.props.date, this.props.selected),
        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
      };
      return m.createElement("div", { ref: this.weekNumberEl, className: Z(i), "aria-label": "".concat(o, " ").concat(this.props.weekNumber), onClick: this.handleClick, onKeyDown: this.handleOnKeyDown, tabIndex: this.getTabIndex() }, e);
    }, a;
  }(J)
), ei = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isDisabled = function(e) {
        return ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.handleDayClick = function(e, r) {
        t.props.onDayClick && t.props.onDayClick(e, r);
      }, t.handleDayMouseEnter = function(e) {
        t.props.onDayMouseEnter && t.props.onDayMouseEnter(e);
      }, t.handleWeekClick = function(e, r, o) {
        for (var s, i, l, c = new Date(e), u = 0; u < 7; u++) {
          var d = new Date(e);
          d.setDate(d.getDate() + u);
          var p = !t.isDisabled(d);
          if (p) {
            c = d;
            break;
          }
        }
        typeof t.props.onWeekSelect == "function" && t.props.onWeekSelect(c, r, o), t.props.showWeekPicker && t.handleDayClick(c, o), ((s = t.props.shouldCloseOnSelect) !== null && s !== void 0 ? s : a.defaultProps.shouldCloseOnSelect) && ((l = (i = t.props).setOpen) === null || l === void 0 || l.call(i, !1));
      }, t.formatWeekNumber = function(e) {
        return t.props.formatWeekNumber ? t.props.formatWeekNumber(e) : Rs(e);
      }, t.renderDays = function() {
        var e = t.startOfWeek(), r = [], o = t.formatWeekNumber(e);
        if (t.props.showWeekNumber) {
          var s = t.props.onWeekSelect || t.props.showWeekPicker ? t.handleWeekClick.bind(t, e, o) : void 0;
          r.push(m.createElement(Js, F({ key: "W" }, a.defaultProps, t.props, { weekNumber: o, date: e, onClick: s })));
        }
        return r.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var l = Te(e, i);
          return m.createElement(Zs, F({}, a.defaultProps, t.props, { ariaLabelPrefixWhenEnabled: t.props.chooseDayAriaLabelPrefix, ariaLabelPrefixWhenDisabled: t.props.disabledDayAriaLabelPrefix, key: l.valueOf(), day: l, onClick: t.handleDayClick.bind(t, l), onMouseEnter: t.handleDayMouseEnter.bind(t, l) }));
        }));
      }, t.startOfWeek = function() {
        return Ee(t.props.day, t.props.locale, t.props.calendarStartDay);
      }, t.isKeyboardSelected = function() {
        return !t.props.disabledKeyboardNavigation && !I(t.startOfWeek(), t.props.selected) && I(t.startOfWeek(), t.props.preSelection);
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          shouldCloseOnSelect: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = {
        "react-datepicker__week": !0,
        "react-datepicker__week--selected": I(this.startOfWeek(), this.props.selected),
        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
      };
      return m.createElement("div", { className: Z(t) }, this.renderDays());
    }, a;
  }(J)
), ze, ti = 6, Be = {
  TWO_COLUMNS: "two_columns",
  THREE_COLUMNS: "three_columns",
  FOUR_COLUMNS: "four_columns"
}, zt = (ze = {}, ze[Be.TWO_COLUMNS] = {
  grid: [
    [0, 1],
    [2, 3],
    [4, 5],
    [6, 7],
    [8, 9],
    [10, 11]
  ],
  verticalNavigationOffset: 2
}, ze[Be.THREE_COLUMNS] = {
  grid: [
    [0, 1, 2],
    [3, 4, 5],
    [6, 7, 8],
    [9, 10, 11]
  ],
  verticalNavigationOffset: 3
}, ze[Be.FOUR_COLUMNS] = {
  grid: [
    [0, 1, 2, 3],
    [4, 5, 6, 7],
    [8, 9, 10, 11]
  ],
  verticalNavigationOffset: 4
}, ze), vt = 1;
function Zr(n, a) {
  return n ? Be.FOUR_COLUMNS : a ? Be.TWO_COLUMNS : Be.THREE_COLUMNS;
}
var ri = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.MONTH_REFS = me([], Array(12), !0).map(function() {
        return Pe();
      }), t.QUARTER_REFS = me([], Array(4), !0).map(function() {
        return Pe();
      }), t.isDisabled = function(e) {
        return ie(e, {
          minDate: t.props.minDate,
          maxDate: t.props.maxDate,
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals,
          includeDateIntervals: t.props.includeDateIntervals,
          includeDates: t.props.includeDates,
          filterDate: t.props.filterDate
        });
      }, t.isExcluded = function(e) {
        return _r(e, {
          excludeDates: t.props.excludeDates,
          excludeDateIntervals: t.props.excludeDateIntervals
        });
      }, t.handleDayClick = function(e, r) {
        var o, s;
        (s = (o = t.props).onDayClick) === null || s === void 0 || s.call(o, e, r, t.props.orderInDisplay);
      }, t.handleDayMouseEnter = function(e) {
        var r, o;
        (o = (r = t.props).onDayMouseEnter) === null || o === void 0 || o.call(r, e);
      }, t.handleMouseLeave = function() {
        var e, r;
        (r = (e = t.props).onMouseLeave) === null || r === void 0 || r.call(e);
      }, t.isRangeStartMonth = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : re(ae(o, e), s);
      }, t.isRangeStartQuarter = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : It(He(o, e), s);
      }, t.isRangeEndMonth = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : re(ae(o, e), i);
      }, t.isRangeEndQuarter = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate;
        return !s || !i ? !1 : It(He(o, e), i);
      }, t.isInSelectingRangeMonth = function(e) {
        var r, o = t.props, s = o.day, i = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, p = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return !(i || l || c) || !p ? !1 : i && d ? pt(p, d, e, s) : l && u || c && u && !d ? pt(u, p, e, s) : !1;
      }, t.isSelectingMonthRangeStart = function(e) {
        var r;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.startDate, l = o.selectsStart, c = ae(s, e), u = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return l ? re(c, u) : re(c, i);
      }, t.isSelectingMonthRangeEnd = function(e) {
        var r;
        if (!t.isInSelectingRangeMonth(e))
          return !1;
        var o = t.props, s = o.day, i = o.endDate, l = o.selectsEnd, c = o.selectsRange, u = ae(s, e), d = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return l || c ? re(u, d) : re(u, i);
      }, t.isInSelectingRangeQuarter = function(e) {
        var r, o = t.props, s = o.day, i = o.selectsStart, l = o.selectsEnd, c = o.selectsRange, u = o.startDate, d = o.endDate, p = (r = t.props.selectingDate) !== null && r !== void 0 ? r : t.props.preSelection;
        return !(i || l || c) || !p ? !1 : i && d ? mt(p, d, e, s) : l && u || c && u && !d ? mt(u, p, e, s) : !1;
      }, t.isWeekInMonth = function(e) {
        var r = t.props.day, o = Te(e, 6);
        return re(e, r) || re(o, r);
      }, t.isCurrentMonth = function(e, r) {
        return R(e) === R(B()) && r === ne(B());
      }, t.isCurrentQuarter = function(e, r) {
        return R(e) === R(B()) && r === Ye(B());
      }, t.isSelectedMonth = function(e, r, o) {
        return ne(o) === r && R(e) === R(o);
      }, t.isSelectMonthInList = function(e, r, o) {
        return o.some(function(s) {
          return t.isSelectedMonth(e, r, s);
        });
      }, t.isSelectedQuarter = function(e, r, o) {
        return Ye(e) === r && R(e) === R(o);
      }, t.renderWeeks = function() {
        for (var e = [], r = t.props.fixedHeight, o = 0, s = !1, i = Ee(Me(t.props.day), t.props.locale, t.props.calendarStartDay), l = function(h) {
          return t.props.showWeekPicker ? Ee(h, t.props.locale, t.props.calendarStartDay) : t.props.preSelection;
        }, c = function(h) {
          return t.props.showWeekPicker ? Ee(h, t.props.locale, t.props.calendarStartDay) : t.props.selected;
        }, u = t.props.selected ? c(t.props.selected) : void 0, d = t.props.preSelection ? l(t.props.preSelection) : void 0; e.push(m.createElement(ei, F({}, t.props, { ariaLabelPrefix: t.props.weekAriaLabelPrefix, key: o, day: i, month: ne(t.props.day), onDayClick: t.handleDayClick, onDayMouseEnter: t.handleDayMouseEnter, selected: u, preSelection: d, showWeekNumber: t.props.showWeekNumbers }))), !s; ) {
          o++, i = Mt(i, 1);
          var p = r && o >= ti, f = !r && !t.isWeekInMonth(i);
          if (p || f)
            if (t.props.peekNextMonth)
              s = !0;
            else
              break;
        }
        return e;
      }, t.onMonthClick = function(e, r) {
        var o = t.isMonthDisabledForLabelDate(r), s = o.isDisabled, i = o.labelDate;
        s || t.handleDayClick(Me(i), e);
      }, t.onMonthMouseEnter = function(e) {
        var r = t.isMonthDisabledForLabelDate(e), o = r.isDisabled, s = r.labelDate;
        o || t.handleDayMouseEnter(Me(s));
      }, t.handleMonthNavigation = function(e, r) {
        var o, s, i, l;
        (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, r), (l = (i = t.MONTH_REFS[e]) === null || i === void 0 ? void 0 : i.current) === null || l === void 0 || l.focus();
      }, t.handleKeyboardNavigation = function(e, r, o) {
        var s, i = t.props, l = i.selected, c = i.preSelection, u = i.setPreSelection, d = i.minDate, p = i.maxDate, f = i.showFourColumnMonthYearPicker, h = i.showTwoColumnMonthYearPicker;
        if (c) {
          var v = Zr(f, h), g = t.getVerticalOffset(v), D = (s = zt[v]) === null || s === void 0 ? void 0 : s.grid, M = function(y, _, C) {
            var L, W, A = _, K = C;
            switch (y) {
              case w.ArrowRight:
                A = we(_, vt), K = C === 11 ? 0 : C + vt;
                break;
              case w.ArrowLeft:
                A = Qe(_, vt), K = C === 0 ? 11 : C - vt;
                break;
              case w.ArrowUp:
                A = Qe(_, g), K = !((L = D == null ? void 0 : D[0]) === null || L === void 0) && L.includes(C) ? C + 12 - g : C - g;
                break;
              case w.ArrowDown:
                A = we(_, g), K = !((W = D == null ? void 0 : D[D.length - 1]) === null || W === void 0) && W.includes(C) ? C - 12 + g : C + g;
                break;
            }
            return { newCalculatedDate: A, newCalculatedMonth: K };
          }, k = function(y, _, C) {
            for (var L = 40, W = y, A = !1, K = 0, V = M(W, _, C), Q = V.newCalculatedDate, T = V.newCalculatedMonth; !A; ) {
              if (K >= L) {
                Q = _, T = C;
                break;
              }
              if (d && Q < d) {
                W = w.ArrowRight;
                var Y = M(W, Q, T);
                Q = Y.newCalculatedDate, T = Y.newCalculatedMonth;
              }
              if (p && Q > p) {
                W = w.ArrowLeft;
                var Y = M(W, Q, T);
                Q = Y.newCalculatedDate, T = Y.newCalculatedMonth;
              }
              if (Bs(Q, t.props)) {
                var Y = M(W, Q, T);
                Q = Y.newCalculatedDate, T = Y.newCalculatedMonth;
              } else
                A = !0;
              K++;
            }
            return { newCalculatedDate: Q, newCalculatedMonth: T };
          };
          if (r === w.Enter) {
            t.isMonthDisabled(o) || (t.onMonthClick(e, o), u == null || u(l));
            return;
          }
          var E = k(r, c, o), S = E.newCalculatedDate, O = E.newCalculatedMonth;
          switch (r) {
            case w.ArrowRight:
            case w.ArrowLeft:
            case w.ArrowUp:
            case w.ArrowDown:
              t.handleMonthNavigation(O, S);
              break;
          }
        }
      }, t.getVerticalOffset = function(e) {
        var r, o;
        return (o = (r = zt[e]) === null || r === void 0 ? void 0 : r.verticalNavigationOffset) !== null && o !== void 0 ? o : 0;
      }, t.onMonthKeyDown = function(e, r) {
        var o = t.props, s = o.disabledKeyboardNavigation, i = o.handleOnMonthKeyDown, l = e.key;
        l !== w.Tab && e.preventDefault(), s || t.handleKeyboardNavigation(e, l, r), i && i(e);
      }, t.onQuarterClick = function(e, r) {
        var o = He(t.props.day, r);
        ft(o, t.props) || t.handleDayClick(Fr(o), e);
      }, t.onQuarterMouseEnter = function(e) {
        var r = He(t.props.day, e);
        ft(r, t.props) || t.handleDayMouseEnter(Fr(r));
      }, t.handleQuarterNavigation = function(e, r) {
        var o, s, i, l;
        t.isDisabled(r) || t.isExcluded(r) || ((s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, r), (l = (i = t.QUARTER_REFS[e - 1]) === null || i === void 0 ? void 0 : i.current) === null || l === void 0 || l.focus());
      }, t.onQuarterKeyDown = function(e, r) {
        var o, s, i = e.key;
        if (!t.props.disabledKeyboardNavigation)
          switch (i) {
            case w.Enter:
              t.onQuarterClick(e, r), (s = (o = t.props).setPreSelection) === null || s === void 0 || s.call(o, t.props.selected);
              break;
            case w.ArrowRight:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(r === 4 ? 1 : r + 1, pr(t.props.preSelection, 1));
              break;
            case w.ArrowLeft:
              if (!t.props.preSelection)
                break;
              t.handleQuarterNavigation(r === 1 ? 4 : r - 1, vn(t.props.preSelection, 1));
              break;
          }
      }, t.isMonthDisabledForLabelDate = function(e) {
        var r, o = t.props, s = o.day, i = o.minDate, l = o.maxDate, c = o.excludeDates, u = o.includeDates, d = ae(s, e);
        return {
          isDisabled: (r = (i || l || c || u) && On(d, t.props)) !== null && r !== void 0 ? r : !1,
          labelDate: d
        };
      }, t.isMonthDisabled = function(e) {
        var r = t.isMonthDisabledForLabelDate(e).isDisabled;
        return r;
      }, t.getMonthClassNames = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate, l = r.preSelection, c = r.monthClassName, u = c ? c(ae(o, e)) : void 0, d = t.getSelection();
        return Z("react-datepicker__month-text", "react-datepicker__month-".concat(e), u, {
          "react-datepicker__month-text--disabled": t.isMonthDisabled(e),
          "react-datepicker__month-text--selected": d ? t.isSelectMonthInList(o, e, d) : void 0,
          "react-datepicker__month-text--keyboard-selected": !t.props.disabledKeyboardNavigation && l && t.isSelectedMonth(o, e, l) && !t.isMonthDisabled(e),
          "react-datepicker__month-text--in-selecting-range": t.isInSelectingRangeMonth(e),
          "react-datepicker__month-text--in-range": s && i ? pt(s, i, e, o) : void 0,
          "react-datepicker__month-text--range-start": t.isRangeStartMonth(e),
          "react-datepicker__month-text--range-end": t.isRangeEndMonth(e),
          "react-datepicker__month-text--selecting-range-start": t.isSelectingMonthRangeStart(e),
          "react-datepicker__month-text--selecting-range-end": t.isSelectingMonthRangeEnd(e),
          "react-datepicker__month-text--today": t.isCurrentMonth(o, e)
        });
      }, t.getTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var r = ne(t.props.preSelection), o = t.isMonthDisabledForLabelDate(r).isDisabled, s = e === r && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return s;
      }, t.getQuarterTabIndex = function(e) {
        if (t.props.preSelection == null)
          return "-1";
        var r = Ye(t.props.preSelection), o = ft(t.props.day, t.props), s = e === r && !(o || t.props.disabledKeyboardNavigation) ? "0" : "-1";
        return s;
      }, t.getAriaLabel = function(e) {
        var r = t.props, o = r.chooseDayAriaLabelPrefix, s = o === void 0 ? "Choose" : o, i = r.disabledDayAriaLabelPrefix, l = i === void 0 ? "Not available" : i, c = r.day, u = r.locale, d = ae(c, e), p = t.isDisabled(d) || t.isExcluded(d) ? l : s;
        return "".concat(p, " ").concat(U(d, "MMMM yyyy", u));
      }, t.getQuarterClassNames = function(e) {
        var r = t.props, o = r.day, s = r.startDate, i = r.endDate, l = r.selected, c = r.minDate, u = r.maxDate, d = r.excludeDates, p = r.includeDates, f = r.filterDate, h = r.preSelection, v = r.disabledKeyboardNavigation, g = (c || u || d || p || f) && ft(He(o, e), t.props);
        return Z("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(e), {
          "react-datepicker__quarter-text--disabled": g,
          "react-datepicker__quarter-text--selected": l ? t.isSelectedQuarter(o, e, l) : void 0,
          "react-datepicker__quarter-text--keyboard-selected": !v && h && t.isSelectedQuarter(o, e, h) && !g,
          "react-datepicker__quarter-text--in-selecting-range": t.isInSelectingRangeQuarter(e),
          "react-datepicker__quarter-text--in-range": s && i ? mt(s, i, e, o) : void 0,
          "react-datepicker__quarter-text--range-start": t.isRangeStartQuarter(e),
          "react-datepicker__quarter-text--range-end": t.isRangeEndQuarter(e)
        });
      }, t.getMonthContent = function(e) {
        var r = t.props, o = r.showFullMonthYearPicker, s = r.renderMonthContent, i = r.locale, l = r.day, c = Tn(e, i), u = br(e, i);
        return s ? s(e, c, u, l) : o ? u : c;
      }, t.getQuarterContent = function(e) {
        var r, o = t.props, s = o.renderQuarterContent, i = o.locale, l = Ws(e, i);
        return (r = s == null ? void 0 : s(e, l)) !== null && r !== void 0 ? r : l;
      }, t.renderMonths = function() {
        var e, r = t.props, o = r.showTwoColumnMonthYearPicker, s = r.showFourColumnMonthYearPicker, i = r.day, l = r.selected, c = (e = zt[Zr(s, o)]) === null || e === void 0 ? void 0 : e.grid;
        return c == null ? void 0 : c.map(function(u, d) {
          return m.createElement("div", { className: "react-datepicker__month-wrapper", key: d }, u.map(function(p, f) {
            return m.createElement("div", { ref: t.MONTH_REFS[p], key: f, onClick: function(h) {
              t.onMonthClick(h, p);
            }, onKeyDown: function(h) {
              Yn(h) && (h.preventDefault(), h.key = w.Enter), t.onMonthKeyDown(h, p);
            }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
              return t.onMonthMouseEnter(p);
            }, onPointerEnter: t.props.usePointerEvent ? function() {
              return t.onMonthMouseEnter(p);
            } : void 0, tabIndex: Number(t.getTabIndex(p)), className: t.getMonthClassNames(p), "aria-disabled": t.isMonthDisabled(p), role: "option", "aria-label": t.getAriaLabel(p), "aria-current": t.isCurrentMonth(i, p) ? "date" : void 0, "aria-selected": l ? t.isSelectedMonth(i, p, l) : void 0 }, t.getMonthContent(p));
          }));
        });
      }, t.renderQuarters = function() {
        var e = t.props, r = e.day, o = e.selected, s = [1, 2, 3, 4];
        return m.createElement("div", { className: "react-datepicker__quarter-wrapper" }, s.map(function(i, l) {
          return m.createElement("div", { key: l, ref: t.QUARTER_REFS[l], role: "option", onClick: function(c) {
            t.onQuarterClick(c, i);
          }, onKeyDown: function(c) {
            t.onQuarterKeyDown(c, i);
          }, onMouseEnter: t.props.usePointerEvent ? void 0 : function() {
            return t.onQuarterMouseEnter(i);
          }, onPointerEnter: t.props.usePointerEvent ? function() {
            return t.onQuarterMouseEnter(i);
          } : void 0, className: t.getQuarterClassNames(i), "aria-selected": o ? t.isSelectedQuarter(r, i, o) : void 0, tabIndex: Number(t.getQuarterTabIndex(i)), "aria-current": t.isCurrentQuarter(r, i) ? "date" : void 0 }, t.getQuarterContent(i));
        }));
      }, t.getClassNames = function() {
        var e = t.props, r = e.selectingDate, o = e.selectsStart, s = e.selectsEnd, i = e.showMonthYearPicker, l = e.showQuarterYearPicker, c = e.showWeekPicker;
        return Z("react-datepicker__month", {
          "react-datepicker__month--selecting-range": r && (o || s)
        }, { "react-datepicker__monthPicker": i }, { "react-datepicker__quarterPicker": l }, { "react-datepicker__weekPicker": c });
      }, t;
    }
    return a.prototype.getSelection = function() {
      var t = this.props, e = t.selected, r = t.selectedDates, o = t.selectsMultiple;
      if (o)
        return r;
      if (e)
        return [e];
    }, a.prototype.render = function() {
      var t = this.props, e = t.showMonthYearPicker, r = t.showQuarterYearPicker, o = t.day, s = t.ariaLabelPrefix, i = s === void 0 ? "Month " : s, l = i ? i.trim() + " " : "";
      return m.createElement("div", { className: this.getClassNames(), onMouseLeave: this.props.usePointerEvent ? void 0 : this.handleMouseLeave, onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : void 0, "aria-label": "".concat(l).concat(U(o, "MMMM, yyyy", this.props.locale)), role: "listbox" }, e ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
    }, a;
  }(J)
), ni = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.isSelectedMonth = function(e) {
        return t.props.month === e;
      }, t.renderOptions = function() {
        return t.props.monthNames.map(function(e, r) {
          return m.createElement(
            "div",
            { className: t.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option", key: e, onClick: t.onChange.bind(t, r), "aria-selected": t.isSelectedMonth(r) ? "true" : void 0 },
            t.isSelectedMonth(r) ? m.createElement("span", { className: "react-datepicker__month-option--selected" }, "✓") : "",
            e
          );
        });
      }, t.onChange = function(e) {
        return t.props.onChange(e);
      }, t.handleClickOutside = function() {
        return t.props.onCancel();
      }, t;
    }
    return a.prototype.render = function() {
      return m.createElement(Qt, { className: "react-datepicker__month-dropdown", onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(J)
), ai = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function(e) {
        return e.map(function(r, o) {
          return m.createElement("option", { key: r, value: o }, r);
        });
      }, t.renderSelectMode = function(e) {
        return m.createElement("select", { value: t.props.month, className: "react-datepicker__month-select", onChange: function(r) {
          return t.onChange(parseInt(r.target.value));
        } }, t.renderSelectOptions(e));
      }, t.renderReadView = function(e, r) {
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-read-view", onClick: t.toggleDropdown },
          m.createElement("span", { className: "react-datepicker__month-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__month-read-view--selected-month" }, r[t.props.month])
        );
      }, t.renderDropdown = function(e) {
        return m.createElement(ni, F({ key: "dropdown" }, t.props, { monthNames: e, onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function(e) {
        var r = t.state.dropdownVisible, o = [t.renderReadView(!r, e)];
        return r && o.unshift(t.renderDropdown(e)), o;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.month && t.props.onChange(e);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t = this, e = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(this.props.useShortMonthInDropdown ? function(o) {
        return Tn(o, t.props.locale);
      } : function(o) {
        return br(o, t.props.locale);
      }), r;
      switch (this.props.dropdownMode) {
        case "scroll":
          r = this.renderScrollMode(e);
          break;
        case "select":
          r = this.renderSelectMode(e);
          break;
      }
      return m.createElement("div", { className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode) }, r);
    }, a;
  }(J)
);
function oi(n, a) {
  for (var t = [], e = Me(n), r = Me(a); !Oe(e, r); )
    t.push(B(e)), e = we(e, 1);
  return t;
}
var si = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.renderOptions = function() {
        return e.state.monthYearsList.map(function(r) {
          var o = nr(r), s = pe(e.props.date, r) && re(e.props.date, r);
          return m.createElement(
            "div",
            { className: s ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option", key: o, onClick: e.onChange.bind(e, o), "aria-selected": s ? "true" : void 0 },
            s ? m.createElement("span", { className: "react-datepicker__month-year-option--selected" }, "✓") : "",
            U(r, e.props.dateFormat, e.props.locale)
          );
        });
      }, e.onChange = function(r) {
        return e.props.onChange(r);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.state = {
        monthYearsList: oi(e.props.minDate, e.props.maxDate)
      }, e;
    }
    return a.prototype.render = function() {
      var t = Z({
        "react-datepicker__month-year-dropdown": !0,
        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
      });
      return m.createElement(Qt, { className: t, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(J)
), ii = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = Me(t.props.minDate), r = Me(t.props.maxDate), o = []; !Oe(e, r); ) {
          var s = nr(e);
          o.push(m.createElement("option", { key: s, value: s }, U(e, t.props.dateFormat, t.props.locale))), e = we(e, 1);
        }
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return m.createElement("select", { value: nr(Me(t.props.date)), className: "react-datepicker__month-year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        var r = U(t.props.date, t.props.dateFormat, t.props.locale);
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__month-year-read-view", onClick: t.toggleDropdown },
          m.createElement("span", { className: "react-datepicker__month-year-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__month-year-read-view--selected-month-year" }, r)
        );
      }, t.renderDropdown = function() {
        return m.createElement(si, F({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, r = [t.renderReadView(!e)];
        return e && r.unshift(t.renderDropdown()), r;
      }, t.onChange = function(e) {
        t.toggleDropdown();
        var r = B(e);
        pe(t.props.date, r) && re(t.props.date, r) || t.props.onChange(r);
      }, t.toggleDropdown = function() {
        return t.setState({
          dropdownVisible: !t.state.dropdownVisible
        });
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return m.createElement("div", { className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(J)
), li = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        height: null
      }, t.scrollToTheSelectedTime = function() {
        requestAnimationFrame(function() {
          var e, r, o;
          t.list && (t.list.scrollTop = (o = t.centerLi && a.calcCenterPosition(t.props.monthRef ? t.props.monthRef.clientHeight - ((r = (e = t.header) === null || e === void 0 ? void 0 : e.clientHeight) !== null && r !== void 0 ? r : 0) : t.list.clientHeight, t.centerLi)) !== null && o !== void 0 ? o : 0);
        });
      }, t.handleClick = function(e) {
        var r, o;
        (t.props.minTime || t.props.maxTime) && Qr(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Br(e, t.props) || (o = (r = t.props).onChange) === null || o === void 0 || o.call(r, e);
      }, t.isSelectedTime = function(e) {
        return t.props.selected && Xs(t.props.selected, e);
      }, t.isDisabledTime = function(e) {
        return (t.props.minTime || t.props.maxTime) && Qr(e, t.props) || (t.props.excludeTimes || t.props.includeTimes || t.props.filterTime) && Br(e, t.props);
      }, t.liClasses = function(e) {
        var r, o = [
          "react-datepicker__time-list-item",
          t.props.timeClassName ? t.props.timeClassName(e) : void 0
        ];
        return t.isSelectedTime(e) && o.push("react-datepicker__time-list-item--selected"), t.isDisabledTime(e) && o.push("react-datepicker__time-list-item--disabled"), t.props.injectTimes && (ve(e) * 3600 + ge(e) * 60 + xe(e)) % (((r = t.props.intervals) !== null && r !== void 0 ? r : a.defaultProps.intervals) * 60) !== 0 && o.push("react-datepicker__time-list-item--injected"), o.join(" ");
      }, t.handleOnKeyDown = function(e, r) {
        var o, s;
        e.key === w.Space && (e.preventDefault(), e.key = w.Enter), (e.key === w.ArrowUp || e.key === w.ArrowLeft) && e.target instanceof HTMLElement && e.target.previousSibling && (e.preventDefault(), e.target.previousSibling instanceof HTMLElement && e.target.previousSibling.focus()), (e.key === w.ArrowDown || e.key === w.ArrowRight) && e.target instanceof HTMLElement && e.target.nextSibling && (e.preventDefault(), e.target.nextSibling instanceof HTMLElement && e.target.nextSibling.focus()), e.key === w.Enter && t.handleClick(r), (s = (o = t.props).handleOnKeyDown) === null || s === void 0 || s.call(o, e);
      }, t.renderTimes = function() {
        for (var e, r = [], o = typeof t.props.format == "string" ? t.props.format : "p", s = (e = t.props.intervals) !== null && e !== void 0 ? e : a.defaultProps.intervals, i = t.props.selected || t.props.openToDate || B(), l = bt(i), c = t.props.injectTimes && t.props.injectTimes.sort(function(g, D) {
          return g.getTime() - D.getTime();
        }), u = 60 * zs(i), d = u / s, p = 0; p < d; p++) {
          var f = tr(l, p * s);
          if (r.push(f), c) {
            var h = js(l, f, p, s, c);
            r = r.concat(h);
          }
        }
        var v = r.reduce(function(g, D) {
          return D.getTime() <= i.getTime() ? D : g;
        }, r[0]);
        return r.map(function(g) {
          return m.createElement("li", { key: g.valueOf(), onClick: t.handleClick.bind(t, g), className: t.liClasses(g), ref: function(D) {
            g === v && (t.centerLi = D);
          }, onKeyDown: function(D) {
            t.handleOnKeyDown(D, g);
          }, tabIndex: g === v ? 0 : -1, role: "option", "aria-selected": t.isSelectedTime(g) ? "true" : void 0, "aria-disabled": t.isDisabledTime(g) ? "true" : void 0 }, U(g, o, t.props.locale));
        });
      }, t.renderTimeCaption = function() {
        return t.props.showTimeCaption === !1 ? m.createElement(m.Fragment, null) : m.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--time ".concat(t.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""), ref: function(e) {
            t.header = e;
          } },
          m.createElement("div", { className: "react-datepicker-time__header" }, t.props.timeCaption)
        );
      }, t;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          intervals: 30,
          todayButton: null,
          timeCaption: "Time",
          showTimeCaption: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
        height: this.props.monthRef.clientHeight - this.header.clientHeight
      });
    }, a.prototype.render = function() {
      var t = this, e, r = this.state.height;
      return m.createElement(
        "div",
        { className: "react-datepicker__time-container ".concat(((e = this.props.todayButton) !== null && e !== void 0 ? e : a.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "") },
        this.renderTimeCaption(),
        m.createElement(
          "div",
          { className: "react-datepicker__time" },
          m.createElement(
            "div",
            { className: "react-datepicker__time-box" },
            m.createElement("ul", { className: "react-datepicker__time-list", ref: function(o) {
              t.list = o;
            }, style: r ? { height: r } : {}, role: "listbox", "aria-label": this.props.timeCaption }, this.renderTimes())
          )
        )
      );
    }, a.calcCenterPosition = function(t, e) {
      return e.offsetTop - (t / 2 - e.clientHeight / 2);
    }, a;
  }(J)
), Jr = 3, ci = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.YEAR_REFS = me([], Array(e.props.yearItemNumber), !0).map(function() {
        return Pe();
      }), e.isDisabled = function(r) {
        return ie(r, {
          minDate: e.props.minDate,
          maxDate: e.props.maxDate,
          excludeDates: e.props.excludeDates,
          includeDates: e.props.includeDates,
          filterDate: e.props.filterDate
        });
      }, e.isExcluded = function(r) {
        return _r(r, {
          excludeDates: e.props.excludeDates
        });
      }, e.selectingDate = function() {
        var r;
        return (r = e.props.selectingDate) !== null && r !== void 0 ? r : e.props.preSelection;
      }, e.updateFocusOnPaginate = function(r) {
        var o = function() {
          var s, i;
          (i = (s = e.YEAR_REFS[r]) === null || s === void 0 ? void 0 : s.current) === null || i === void 0 || i.focus();
        };
        window.requestAnimationFrame(o);
      }, e.handleYearClick = function(r, o) {
        e.props.onDayClick && e.props.onDayClick(r, o);
      }, e.handleYearNavigation = function(r, o) {
        var s, i, l, c, u = e.props, d = u.date, p = u.yearItemNumber;
        if (!(d === void 0 || p === void 0)) {
          var f = Ce(d, p).startPeriod;
          e.isDisabled(o) || e.isExcluded(o) || ((i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, o), r - f < 0 ? e.updateFocusOnPaginate(p - (f - r)) : r - f >= p ? e.updateFocusOnPaginate(Math.abs(p - (r - f))) : (c = (l = e.YEAR_REFS[r - f]) === null || l === void 0 ? void 0 : l.current) === null || c === void 0 || c.focus());
        }
      }, e.isSameDay = function(r, o) {
        return I(r, o);
      }, e.isCurrentYear = function(r) {
        return r === R(B());
      }, e.isRangeStart = function(r) {
        return e.props.startDate && e.props.endDate && pe(de(B(), r), e.props.startDate);
      }, e.isRangeEnd = function(r) {
        return e.props.startDate && e.props.endDate && pe(de(B(), r), e.props.endDate);
      }, e.isInRange = function(r) {
        return ht(r, e.props.startDate, e.props.endDate);
      }, e.isInSelectingRange = function(r) {
        var o = e.props, s = o.selectsStart, i = o.selectsEnd, l = o.selectsRange, c = o.startDate, u = o.endDate;
        return !(s || i || l) || !e.selectingDate() ? !1 : s && u ? ht(r, e.selectingDate(), u) : i && c || l && c && !u ? ht(r, c, e.selectingDate()) : !1;
      }, e.isSelectingRangeStart = function(r) {
        var o;
        if (!e.isInSelectingRange(r))
          return !1;
        var s = e.props, i = s.startDate, l = s.selectsStart, c = de(B(), r);
        return l ? pe(c, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : pe(c, i ?? null);
      }, e.isSelectingRangeEnd = function(r) {
        var o;
        if (!e.isInSelectingRange(r))
          return !1;
        var s = e.props, i = s.endDate, l = s.selectsEnd, c = s.selectsRange, u = de(B(), r);
        return l || c ? pe(u, (o = e.selectingDate()) !== null && o !== void 0 ? o : null) : pe(u, i ?? null);
      }, e.isKeyboardSelected = function(r) {
        if (!(e.props.date === void 0 || e.props.selected == null || e.props.preSelection == null)) {
          var o = e.props, s = o.minDate, i = o.maxDate, l = o.excludeDates, c = o.includeDates, u = o.filterDate, d = Xe(de(e.props.date, r)), p = (s || i || l || c || u) && _t(r, e.props);
          return !e.props.disabledKeyboardNavigation && !e.props.inline && !I(d, Xe(e.props.selected)) && I(d, Xe(e.props.preSelection)) && !p;
        }
      }, e.onYearClick = function(r, o) {
        var s = e.props.date;
        s !== void 0 && e.handleYearClick(Xe(de(s, o)), r);
      }, e.onYearKeyDown = function(r, o) {
        var s, i, l = r.key, c = e.props, u = c.date, d = c.yearItemNumber, p = c.handleOnKeyDown;
        if (l !== w.Tab && r.preventDefault(), !e.props.disabledKeyboardNavigation)
          switch (l) {
            case w.Enter:
              if (e.props.selected == null)
                break;
              e.onYearClick(r, o), (i = (s = e.props).setPreSelection) === null || i === void 0 || i.call(s, e.props.selected);
              break;
            case w.ArrowRight:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o + 1, ke(e.props.preSelection, 1));
              break;
            case w.ArrowLeft:
              if (e.props.preSelection == null)
                break;
              e.handleYearNavigation(o - 1, Ke(e.props.preSelection, 1));
              break;
            case w.ArrowUp: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var f = Ce(u, d).startPeriod, h = Jr, v = o - h;
              if (v < f) {
                var g = d % h;
                o >= f && o < f + g ? h = g : h += g, v = o - h;
              }
              e.handleYearNavigation(v, Ke(e.props.preSelection, h));
              break;
            }
            case w.ArrowDown: {
              if (u === void 0 || d === void 0 || e.props.preSelection == null)
                break;
              var D = Ce(u, d).endPeriod, h = Jr, v = o + h;
              if (v > D) {
                var g = d % h;
                o <= D && o > D - g ? h = g : h += g, v = o + h;
              }
              e.handleYearNavigation(v, ke(e.props.preSelection, h));
              break;
            }
          }
        p && p(r);
      }, e.getYearClassNames = function(r) {
        var o = e.props, s = o.date, i = o.minDate, l = o.maxDate, c = o.selected, u = o.excludeDates, d = o.includeDates, p = o.filterDate, f = o.yearClassName;
        return Z("react-datepicker__year-text", "react-datepicker__year-".concat(r), s ? f == null ? void 0 : f(de(s, r)) : void 0, {
          "react-datepicker__year-text--selected": c ? r === R(c) : void 0,
          "react-datepicker__year-text--disabled": (i || l || u || d || p) && _t(r, e.props),
          "react-datepicker__year-text--keyboard-selected": e.isKeyboardSelected(r),
          "react-datepicker__year-text--range-start": e.isRangeStart(r),
          "react-datepicker__year-text--range-end": e.isRangeEnd(r),
          "react-datepicker__year-text--in-range": e.isInRange(r),
          "react-datepicker__year-text--in-selecting-range": e.isInSelectingRange(r),
          "react-datepicker__year-text--selecting-range-start": e.isSelectingRangeStart(r),
          "react-datepicker__year-text--selecting-range-end": e.isSelectingRangeEnd(r),
          "react-datepicker__year-text--today": e.isCurrentYear(r)
        });
      }, e.getYearTabIndex = function(r) {
        if (e.props.disabledKeyboardNavigation || e.props.preSelection == null)
          return "-1";
        var o = R(e.props.preSelection), s = _t(r, e.props);
        return r === o && !s ? "0" : "-1";
      }, e.getYearContainerClassNames = function() {
        var r = e.props, o = r.selectingDate, s = r.selectsStart, i = r.selectsEnd, l = r.selectsRange;
        return Z("react-datepicker__year", {
          "react-datepicker__year--selecting-range": o && (s || i || l)
        });
      }, e.getYearContent = function(r) {
        return e.props.renderYearContent ? e.props.renderYearContent(r) : r;
      }, e;
    }
    return a.prototype.render = function() {
      var t = this, e = [], r = this.props, o = r.date, s = r.yearItemNumber, i = r.onYearMouseEnter, l = r.onYearMouseLeave;
      if (o === void 0)
        return null;
      for (var c = Ce(o, s), u = c.startPeriod, d = c.endPeriod, p = function(v) {
        e.push(m.createElement("div", { ref: f.YEAR_REFS[v - u], onClick: function(g) {
          t.onYearClick(g, v);
        }, onKeyDown: function(g) {
          Yn(g) && (g.preventDefault(), g.key = w.Enter), t.onYearKeyDown(g, v);
        }, tabIndex: Number(f.getYearTabIndex(v)), className: f.getYearClassNames(v), onMouseEnter: f.props.usePointerEvent ? void 0 : function(g) {
          return i(g, v);
        }, onPointerEnter: f.props.usePointerEvent ? function(g) {
          return i(g, v);
        } : void 0, onMouseLeave: f.props.usePointerEvent ? void 0 : function(g) {
          return l(g, v);
        }, onPointerLeave: f.props.usePointerEvent ? function(g) {
          return l(g, v);
        } : void 0, key: v, "aria-current": f.isCurrentYear(v) ? "date" : void 0 }, f.getYearContent(v)));
      }, f = this, h = u; h <= d; h++)
        p(h);
      return m.createElement(
        "div",
        { className: this.getYearContainerClassNames() },
        m.createElement("div", { className: "react-datepicker__year-wrapper", onMouseLeave: this.props.usePointerEvent ? void 0 : this.props.clearSelectingDate, onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : void 0 }, e)
      );
    }, a;
  }(J)
);
function ui(n, a, t, e) {
  for (var r = [], o = 0; o < 2 * a + 1; o++) {
    var s = n + a - o, i = !0;
    t && (i = R(t) <= s), e && i && (i = R(e) >= s), i && r.push(s);
  }
  return r;
}
var di = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      e.renderOptions = function() {
        var i = e.props.year, l = e.state.yearsList.map(function(d) {
          return m.createElement(
            "div",
            { className: i === d ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option", key: d, onClick: e.onChange.bind(e, d), "aria-selected": i === d ? "true" : void 0 },
            i === d ? m.createElement("span", { className: "react-datepicker__year-option--selected" }, "✓") : "",
            d
          );
        }), c = e.props.minDate ? R(e.props.minDate) : null, u = e.props.maxDate ? R(e.props.maxDate) : null;
        return (!u || !e.state.yearsList.find(function(d) {
          return d === u;
        })) && l.unshift(m.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "upcoming", onClick: e.incrementYears },
          m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming" })
        )), (!c || !e.state.yearsList.find(function(d) {
          return d === c;
        })) && l.push(m.createElement(
          "div",
          { className: "react-datepicker__year-option", key: "previous", onClick: e.decrementYears },
          m.createElement("a", { className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous" })
        )), l;
      }, e.onChange = function(i) {
        e.props.onChange(i);
      }, e.handleClickOutside = function() {
        e.props.onCancel();
      }, e.shiftYears = function(i) {
        var l = e.state.yearsList.map(function(c) {
          return c + i;
        });
        e.setState({
          yearsList: l
        });
      }, e.incrementYears = function() {
        return e.shiftYears(1);
      }, e.decrementYears = function() {
        return e.shiftYears(-1);
      };
      var r = t.yearDropdownItemNumber, o = t.scrollableYearDropdown, s = r || (o ? 10 : 5);
      return e.state = {
        yearsList: ui(e.props.year, s, e.props.minDate, e.props.maxDate)
      }, e.dropdownRef = Pe(), e;
    }
    return a.prototype.componentDidMount = function() {
      var t = this.dropdownRef.current;
      if (t) {
        var e = t.children ? Array.from(t.children) : null, r = e ? e.find(function(o) {
          return o.ariaSelected;
        }) : null;
        t.scrollTop = r && r instanceof HTMLElement ? r.offsetTop + (r.clientHeight - t.clientHeight) / 2 : (t.scrollHeight - t.clientHeight) / 2;
      }
    }, a.prototype.render = function() {
      var t = Z({
        "react-datepicker__year-dropdown": !0,
        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
      });
      return m.createElement(Qt, { className: t, containerRef: this.dropdownRef, onClickOutside: this.handleClickOutside }, this.renderOptions());
    }, a;
  }(J)
), pi = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      var t = n !== null && n.apply(this, arguments) || this;
      return t.state = {
        dropdownVisible: !1
      }, t.renderSelectOptions = function() {
        for (var e = t.props.minDate ? R(t.props.minDate) : 1900, r = t.props.maxDate ? R(t.props.maxDate) : 2100, o = [], s = e; s <= r; s++)
          o.push(m.createElement("option", { key: s, value: s }, s));
        return o;
      }, t.onSelectChange = function(e) {
        t.onChange(parseInt(e.target.value));
      }, t.renderSelectMode = function() {
        return m.createElement("select", { value: t.props.year, className: "react-datepicker__year-select", onChange: t.onSelectChange }, t.renderSelectOptions());
      }, t.renderReadView = function(e) {
        return m.createElement(
          "div",
          { key: "read", style: { visibility: e ? "visible" : "hidden" }, className: "react-datepicker__year-read-view", onClick: function(r) {
            return t.toggleDropdown(r);
          } },
          m.createElement("span", { className: "react-datepicker__year-read-view--down-arrow" }),
          m.createElement("span", { className: "react-datepicker__year-read-view--selected-year" }, t.props.year)
        );
      }, t.renderDropdown = function() {
        return m.createElement(di, F({ key: "dropdown" }, t.props, { onChange: t.onChange, onCancel: t.toggleDropdown }));
      }, t.renderScrollMode = function() {
        var e = t.state.dropdownVisible, r = [t.renderReadView(!e)];
        return e && r.unshift(t.renderDropdown()), r;
      }, t.onChange = function(e) {
        t.toggleDropdown(), e !== t.props.year && t.props.onChange(e);
      }, t.toggleDropdown = function(e) {
        t.setState({
          dropdownVisible: !t.state.dropdownVisible
        }, function() {
          t.props.adjustDateOnChange && t.handleYearChange(t.props.date, e);
        });
      }, t.handleYearChange = function(e, r) {
        var o;
        (o = t.onSelect) === null || o === void 0 || o.call(t, e, r), t.setOpen();
      }, t.onSelect = function(e, r) {
        var o, s;
        (s = (o = t.props).onSelect) === null || s === void 0 || s.call(o, e, r);
      }, t.setOpen = function() {
        var e, r;
        (r = (e = t.props).setOpen) === null || r === void 0 || r.call(e, !0);
      }, t;
    }
    return a.prototype.render = function() {
      var t;
      switch (this.props.dropdownMode) {
        case "scroll":
          t = this.renderScrollMode();
          break;
        case "select":
          t = this.renderSelectMode();
          break;
      }
      return m.createElement("div", { className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode) }, t);
    }, a;
  }(J)
), fi = [
  "react-datepicker__year-select",
  "react-datepicker__month-select",
  "react-datepicker__month-year-select"
], hi = function(n) {
  var a = (n.className || "").split(/\s+/);
  return fi.some(function(t) {
    return a.indexOf(t) >= 0;
  });
}, mi = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.monthContainer = void 0, e.handleClickOutside = function(r) {
        e.props.onClickOutside(r);
      }, e.setClickOutsideRef = function() {
        return e.containerRef.current;
      }, e.handleDropdownFocus = function(r) {
        var o, s;
        hi(r.target) && ((s = (o = e.props).onDropdownFocus) === null || s === void 0 || s.call(o, r));
      }, e.getDateInView = function() {
        var r = e.props, o = r.preSelection, s = r.selected, i = r.openToDate, l = Nn(e.props), c = Rn(e.props), u = B(), d = i || s || o;
        return d || (l && Fe(u, l) ? l : c && Oe(u, c) ? c : u);
      }, e.increaseMonth = function() {
        e.setState(function(r) {
          var o = r.date;
          return {
            date: we(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.decreaseMonth = function() {
        e.setState(function(r) {
          var o = r.date;
          return {
            date: Qe(o, 1)
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.handleDayClick = function(r, o, s) {
        e.props.onSelect(r, o, s), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.handleDayMouseEnter = function(r) {
        e.setState({ selectingDate: r }), e.props.onDayMouseEnter && e.props.onDayMouseEnter(r);
      }, e.handleMonthMouseLeave = function() {
        e.setState({ selectingDate: void 0 }), e.props.onMonthMouseLeave && e.props.onMonthMouseLeave();
      }, e.handleYearMouseEnter = function(r, o) {
        e.setState({ selectingDate: de(B(), o) }), e.props.onYearMouseEnter && e.props.onYearMouseEnter(r, o);
      }, e.handleYearMouseLeave = function(r, o) {
        e.props.onYearMouseLeave && e.props.onYearMouseLeave(r, o);
      }, e.handleYearChange = function(r) {
        var o, s, i, l;
        (s = (o = e.props).onYearChange) === null || s === void 0 || s.call(o, r), e.setState({ isRenderAriaLiveMessage: !0 }), e.props.adjustDateOnChange && (e.props.onSelect(r), (l = (i = e.props).setOpen) === null || l === void 0 || l.call(i, !0)), e.props.setPreSelection && e.props.setPreSelection(r);
      }, e.getEnabledPreSelectionDateForMonth = function(r) {
        if (!ie(r, e.props))
          return r;
        for (var o = Me(r), s = Ls(r), i = na(s, o), l = null, c = 0; c <= i; c++) {
          var u = Te(o, c);
          if (!ie(u, e.props)) {
            l = u;
            break;
          }
        }
        return l;
      }, e.handleMonthChange = function(r) {
        var o, s, i, l = (o = e.getEnabledPreSelectionDateForMonth(r)) !== null && o !== void 0 ? o : r;
        e.handleCustomMonthChange(l), e.props.adjustDateOnChange && (e.props.onSelect(l), (i = (s = e.props).setOpen) === null || i === void 0 || i.call(s, !0)), e.props.setPreSelection && e.props.setPreSelection(l);
      }, e.handleCustomMonthChange = function(r) {
        var o, s;
        (s = (o = e.props).onMonthChange) === null || s === void 0 || s.call(o, r), e.setState({ isRenderAriaLiveMessage: !0 });
      }, e.handleMonthYearChange = function(r) {
        e.handleYearChange(r), e.handleMonthChange(r);
      }, e.changeYear = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: de(s, Number(r))
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.changeMonth = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: ae(s, Number(r))
          };
        }, function() {
          return e.handleMonthChange(e.state.date);
        });
      }, e.changeMonthYear = function(r) {
        e.setState(function(o) {
          var s = o.date;
          return {
            date: de(ae(s, ne(r)), R(r))
          };
        }, function() {
          return e.handleMonthYearChange(e.state.date);
        });
      }, e.header = function(r) {
        r === void 0 && (r = e.state.date);
        var o = Ee(r, e.props.locale, e.props.calendarStartDay), s = [];
        return e.props.showWeekNumbers && s.push(m.createElement("div", { key: "W", className: "react-datepicker__day-name" }, e.props.weekLabel || "#")), s.concat([0, 1, 2, 3, 4, 5, 6].map(function(i) {
          var l = Te(o, i), c = e.formatWeekday(l, e.props.locale), u = e.props.weekDayClassName ? e.props.weekDayClassName(l) : void 0;
          return m.createElement("div", { key: i, "aria-label": U(l, "EEEE", e.props.locale), className: Z("react-datepicker__day-name", u) }, c);
        }));
      }, e.formatWeekday = function(r, o) {
        return e.props.formatWeekDay ? Fs(r, e.props.formatWeekDay, o) : e.props.useWeekdaysShort ? Hs(r, o) : As(r, o);
      }, e.decreaseYear = function() {
        e.setState(function(r) {
          var o, s = r.date;
          return {
            date: Ke(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.clearSelectingDate = function() {
        e.setState({ selectingDate: void 0 });
      }, e.renderPreviousButton = function() {
        var r;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = Ur(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = Vs(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = Qs(e.state.date, e.props);
              break;
            default:
              o = Kr(e.state.date, e.props);
              break;
          }
          if (!(!((r = e.props.forceShowMonthNavigation) !== null && r !== void 0 ? r : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var s = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--previous"
            ], i = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--previous"
            ], l = e.decreaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (l = e.decreaseYear), o && e.props.showDisabledMonthNavigation && (i.push("react-datepicker__navigation--previous--disabled"), l = void 0);
            var c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.previousMonthButtonLabel, p = d === void 0 ? a.defaultProps.previousMonthButtonLabel : d, f = u.previousYearButtonLabel, h = f === void 0 ? a.defaultProps.previousYearButtonLabel : f, v = e.props, g = v.previousMonthAriaLabel, D = g === void 0 ? typeof p == "string" ? p : "Previous Month" : g, M = v.previousYearAriaLabel, k = M === void 0 ? typeof h == "string" ? h : "Previous Year" : M;
            return m.createElement(
              "button",
              { type: "button", className: i.join(" "), onClick: l, onKeyDown: e.props.handleOnKeyDown, "aria-label": c ? k : D },
              m.createElement("span", { className: s.join(" ") }, c ? h : p)
            );
          }
        }
      }, e.increaseYear = function() {
        e.setState(function(r) {
          var o, s = r.date;
          return {
            date: ke(s, e.props.showYearPicker ? (o = e.props.yearItemNumber) !== null && o !== void 0 ? o : a.defaultProps.yearItemNumber : 1)
          };
        }, function() {
          return e.handleYearChange(e.state.date);
        });
      }, e.renderNextButton = function() {
        var r;
        if (!e.props.renderCustomHeader) {
          var o;
          switch (!0) {
            case e.props.showMonthYearPicker:
              o = qr(e.state.date, e.props);
              break;
            case e.props.showYearPicker:
              o = Us(e.state.date, e.props);
              break;
            case e.props.showQuarterYearPicker:
              o = Ks(e.state.date, e.props);
              break;
            default:
              o = Vr(e.state.date, e.props);
              break;
          }
          if (!(!((r = e.props.forceShowMonthNavigation) !== null && r !== void 0 ? r : a.defaultProps.forceShowMonthNavigation) && !e.props.showDisabledMonthNavigation && o || e.props.showTimeSelectOnly)) {
            var s = [
              "react-datepicker__navigation",
              "react-datepicker__navigation--next"
            ], i = [
              "react-datepicker__navigation-icon",
              "react-datepicker__navigation-icon--next"
            ];
            e.props.showTimeSelect && s.push("react-datepicker__navigation--next--with-time"), e.props.todayButton && s.push("react-datepicker__navigation--next--with-today-button");
            var l = e.increaseMonth;
            (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker) && (l = e.increaseYear), o && e.props.showDisabledMonthNavigation && (s.push("react-datepicker__navigation--next--disabled"), l = void 0);
            var c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker, u = e.props, d = u.nextMonthButtonLabel, p = d === void 0 ? a.defaultProps.nextMonthButtonLabel : d, f = u.nextYearButtonLabel, h = f === void 0 ? a.defaultProps.nextYearButtonLabel : f, v = e.props, g = v.nextMonthAriaLabel, D = g === void 0 ? typeof p == "string" ? p : "Next Month" : g, M = v.nextYearAriaLabel, k = M === void 0 ? typeof h == "string" ? h : "Next Year" : M;
            return m.createElement(
              "button",
              { type: "button", className: s.join(" "), onClick: l, onKeyDown: e.props.handleOnKeyDown, "aria-label": c ? k : D },
              m.createElement("span", { className: i.join(" ") }, c ? h : p)
            );
          }
        }
      }, e.renderCurrentMonth = function(r) {
        r === void 0 && (r = e.state.date);
        var o = ["react-datepicker__current-month"];
        return e.props.showYearDropdown && o.push("react-datepicker__current-month--hasYearDropdown"), e.props.showMonthDropdown && o.push("react-datepicker__current-month--hasMonthDropdown"), e.props.showMonthYearDropdown && o.push("react-datepicker__current-month--hasMonthYearDropdown"), m.createElement("h2", { className: o.join(" ") }, U(r, e.props.dateFormat, e.props.locale));
      }, e.renderYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showYearDropdown || r))
          return m.createElement(pi, F({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeYear, year: R(e.state.date) }));
      }, e.renderMonthDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthDropdown || r))
          return m.createElement(ai, F({}, a.defaultProps, e.props, { month: ne(e.state.date), onChange: e.changeMonth }));
      }, e.renderMonthYearDropdown = function(r) {
        if (r === void 0 && (r = !1), !(!e.props.showMonthYearDropdown || r))
          return m.createElement(ii, F({}, a.defaultProps, e.props, { date: e.state.date, onChange: e.changeMonthYear }));
      }, e.handleTodayButtonClick = function(r) {
        e.props.onSelect(Ar(), r), e.props.setPreSelection && e.props.setPreSelection(Ar());
      }, e.renderTodayButton = function() {
        if (!(!e.props.todayButton || e.props.showTimeSelectOnly))
          return m.createElement("div", { className: "react-datepicker__today-button", onClick: e.handleTodayButtonClick }, e.props.todayButton);
      }, e.renderDefaultHeader = function(r) {
        var o = r.monthDate, s = r.i;
        return m.createElement(
          "div",
          { className: "react-datepicker__header ".concat(e.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "") },
          e.renderCurrentMonth(o),
          m.createElement(
            "div",
            { className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(e.props.dropdownMode), onFocus: e.handleDropdownFocus },
            e.renderMonthDropdown(s !== 0),
            e.renderMonthYearDropdown(s !== 0),
            e.renderYearDropdown(s !== 0)
          ),
          m.createElement("div", { className: "react-datepicker__day-names" }, e.header(o))
        );
      }, e.renderCustomHeader = function(r) {
        var o, s, i = r.monthDate, l = r.i;
        if (e.props.showTimeSelect && !e.state.monthContainer || e.props.showTimeSelectOnly)
          return null;
        var c = Kr(e.state.date, e.props), u = Vr(e.state.date, e.props), d = Ur(e.state.date, e.props), p = qr(e.state.date, e.props), f = !e.props.showMonthYearPicker && !e.props.showQuarterYearPicker && !e.props.showYearPicker;
        return m.createElement(
          "div",
          { className: "react-datepicker__header react-datepicker__header--custom", onFocus: e.props.onDropdownFocus },
          (s = (o = e.props).renderCustomHeader) === null || s === void 0 ? void 0 : s.call(o, F(F({}, e.state), { customHeaderCount: l, monthDate: i, changeMonth: e.changeMonth, changeYear: e.changeYear, decreaseMonth: e.decreaseMonth, increaseMonth: e.increaseMonth, decreaseYear: e.decreaseYear, increaseYear: e.increaseYear, prevMonthButtonDisabled: c, nextMonthButtonDisabled: u, prevYearButtonDisabled: d, nextYearButtonDisabled: p })),
          f && m.createElement("div", { className: "react-datepicker__day-names" }, e.header(i))
        );
      }, e.renderYearHeader = function(r) {
        var o = r.monthDate, s = e.props, i = s.showYearPicker, l = s.yearItemNumber, c = l === void 0 ? a.defaultProps.yearItemNumber : l, u = Ce(o, c), d = u.startPeriod, p = u.endPeriod;
        return m.createElement("div", { className: "react-datepicker__header react-datepicker-year-header" }, i ? "".concat(d, " - ").concat(p) : R(o));
      }, e.renderHeader = function(r) {
        var o = r.monthDate, s = r.i, i = s === void 0 ? 0 : s, l = { monthDate: o, i };
        switch (!0) {
          case e.props.renderCustomHeader !== void 0:
            return e.renderCustomHeader(l);
          case (e.props.showMonthYearPicker || e.props.showQuarterYearPicker || e.props.showYearPicker):
            return e.renderYearHeader(l);
          default:
            return e.renderDefaultHeader(l);
        }
      }, e.renderMonths = function() {
        var r, o;
        if (!(e.props.showTimeSelectOnly || e.props.showYearPicker)) {
          for (var s = [], i = (r = e.props.monthsShown) !== null && r !== void 0 ? r : a.defaultProps.monthsShown, l = e.props.showPreviousMonths ? i - 1 : 0, c = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? ke(e.state.date, l) : Qe(e.state.date, l), u = (o = e.props.monthSelectedIn) !== null && o !== void 0 ? o : l, d = 0; d < i; ++d) {
            var p = d - u + l, f = e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? ke(c, p) : we(c, p), h = "month-".concat(d), v = d < i - 1, g = d > 0;
            s.push(m.createElement(
              "div",
              { key: h, ref: function(D) {
                e.monthContainer = D ?? void 0;
              }, className: "react-datepicker__month-container" },
              e.renderHeader({ monthDate: f, i: d }),
              m.createElement(ri, F({}, a.defaultProps, e.props, { ariaLabelPrefix: e.props.monthAriaLabelPrefix, day: f, onDayClick: e.handleDayClick, handleOnKeyDown: e.props.handleOnDayKeyDown, handleOnMonthKeyDown: e.props.handleOnKeyDown, onDayMouseEnter: e.handleDayMouseEnter, onMouseLeave: e.handleMonthMouseLeave, orderInDisplay: d, selectingDate: e.state.selectingDate, monthShowsDuplicateDaysEnd: v, monthShowsDuplicateDaysStart: g }))
            ));
          }
          return s;
        }
      }, e.renderYears = function() {
        if (!e.props.showTimeSelectOnly && e.props.showYearPicker)
          return m.createElement(
            "div",
            { className: "react-datepicker__year--container" },
            e.renderHeader({ monthDate: e.state.date }),
            m.createElement(ci, F({}, a.defaultProps, e.props, { selectingDate: e.state.selectingDate, date: e.state.date, onDayClick: e.handleDayClick, clearSelectingDate: e.clearSelectingDate, onYearMouseEnter: e.handleYearMouseEnter, onYearMouseLeave: e.handleYearMouseLeave }))
          );
      }, e.renderTimeSection = function() {
        if (e.props.showTimeSelect && (e.state.monthContainer || e.props.showTimeSelectOnly))
          return m.createElement(li, F({}, a.defaultProps, e.props, { onChange: e.props.onTimeChange, format: e.props.timeFormat, intervals: e.props.timeIntervals, monthRef: e.state.monthContainer }));
      }, e.renderInputTimeSection = function() {
        var r = e.props.selected ? new Date(e.props.selected) : void 0, o = r && _e(r) && !!e.props.selected, s = o ? "".concat(jr(r.getHours()), ":").concat(jr(r.getMinutes())) : "";
        if (e.props.showTimeInput)
          return m.createElement(Gs, F({}, a.defaultProps, e.props, { date: r, timeString: s, onChange: e.props.onTimeChange }));
      }, e.renderAriaLiveRegion = function() {
        var r, o = Ce(e.state.date, (r = e.props.yearItemNumber) !== null && r !== void 0 ? r : a.defaultProps.yearItemNumber), s = o.startPeriod, i = o.endPeriod, l;
        return e.props.showYearPicker ? l = "".concat(s, " - ").concat(i) : e.props.showMonthYearPicker || e.props.showQuarterYearPicker ? l = R(e.state.date) : l = "".concat(br(ne(e.state.date), e.props.locale), " ").concat(R(e.state.date)), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, e.state.isRenderAriaLiveMessage && l);
      }, e.renderChildren = function() {
        if (e.props.children)
          return m.createElement("div", { className: "react-datepicker__children-container" }, e.props.children);
      }, e.containerRef = Pe(), e.state = {
        date: e.getDateInView(),
        selectingDate: void 0,
        monthContainer: void 0,
        isRenderAriaLiveMessage: !1
      }, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          monthsShown: 1,
          forceShowMonthNavigation: !1,
          timeCaption: "Time",
          previousYearButtonLabel: "Previous Year",
          nextYearButtonLabel: "Next Year",
          previousMonthButtonLabel: "Previous Month",
          nextMonthButtonLabel: "Next Month",
          yearItemNumber: it
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      var t = this;
      this.props.showTimeSelect && (this.assignMonthContainer = function() {
        t.setState({ monthContainer: t.monthContainer });
      }());
    }, a.prototype.componentDidUpdate = function(t) {
      var e = this;
      if (this.props.preSelection && (!I(this.props.preSelection, t.preSelection) || this.props.monthSelectedIn !== t.monthSelectedIn)) {
        var r = !re(this.state.date, this.props.preSelection);
        this.setState({
          date: this.props.preSelection
        }, function() {
          return r && e.handleCustomMonthChange(e.state.date);
        });
      } else this.props.openToDate && !I(this.props.openToDate, t.openToDate) && this.setState({
        date: this.props.openToDate
      });
    }, a.prototype.render = function() {
      var t = this.props.container || Es;
      return m.createElement(
        Qt,
        { onClickOutside: this.handleClickOutside, style: { display: "contents" }, containerRef: this.containerRef, ignoreClass: this.props.outsideClickIgnoreClass },
        m.createElement(
          t,
          { className: Z("react-datepicker", this.props.className, {
            "react-datepicker--time-only": this.props.showTimeSelectOnly
          }), showTime: this.props.showTimeSelect || this.props.showTimeInput, showTimeSelectOnly: this.props.showTimeSelectOnly },
          this.renderAriaLiveRegion(),
          this.renderPreviousButton(),
          this.renderNextButton(),
          this.renderMonths(),
          this.renderYears(),
          this.renderTodayButton(),
          this.renderTimeSection(),
          this.renderInputTimeSection(),
          this.renderChildren()
        )
      );
    }, a;
  }(J)
), vi = function(n) {
  var a = n.icon, t = n.className, e = t === void 0 ? "" : t, r = n.onClick, o = "react-datepicker__calendar-icon";
  return typeof a == "string" ? m.createElement("i", { className: "".concat(o, " ").concat(a, " ").concat(e), "aria-hidden": "true", onClick: r }) : m.isValidElement(a) ? m.cloneElement(a, {
    className: "".concat(a.props.className || "", " ").concat(o, " ").concat(e),
    onClick: function(s) {
      typeof a.props.onClick == "function" && a.props.onClick(s), typeof r == "function" && r(s);
    }
  }) : m.createElement(
    "svg",
    { className: "".concat(o, " ").concat(e), xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 448 512", onClick: r },
    m.createElement("path", { d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z" })
  );
}, In = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.portalRoot = null, e.el = document.createElement("div"), e;
    }
    return a.prototype.componentDidMount = function() {
      this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
    }, a.prototype.componentWillUnmount = function() {
      this.portalRoot && this.portalRoot.removeChild(this.el);
    }, a.prototype.render = function() {
      return Zn.createPortal(this.props.children, this.el);
    }, a;
  }(J)
), gi = "[tabindex], a, button, input, select, textarea", Di = function(n) {
  return (n instanceof HTMLAnchorElement || !n.disabled) && n.tabIndex !== -1;
}, Ln = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.getTabChildren = function() {
        var r;
        return Array.prototype.slice.call((r = e.tabLoopRef.current) === null || r === void 0 ? void 0 : r.querySelectorAll(gi), 1, -1).filter(Di);
      }, e.handleFocusStart = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[r.length - 1].focus();
      }, e.handleFocusEnd = function() {
        var r = e.getTabChildren();
        r && r.length > 1 && r[0].focus();
      }, e.tabLoopRef = Pe(), e;
    }
    return a.prototype.render = function() {
      var t;
      return ((t = this.props.enableTabLoop) !== null && t !== void 0 ? t : a.defaultProps.enableTabLoop) ? m.createElement(
        "div",
        { className: "react-datepicker__tab-loop", ref: this.tabLoopRef },
        m.createElement("div", { className: "react-datepicker__tab-loop__start", tabIndex: 0, onFocus: this.handleFocusStart }),
        this.props.children,
        m.createElement("div", { className: "react-datepicker__tab-loop__end", tabIndex: 0, onFocus: this.handleFocusEnd })
      ) : this.props.children;
    }, a.defaultProps = {
      enableTabLoop: !0
    }, a;
  }(J)
);
function wi(n) {
  var a = function(t) {
    var e, r = typeof t.hidePopper == "boolean" ? t.hidePopper : !0, o = kt(null), s = Ss(F({ open: !r, whileElementsMounted: ns, placement: t.popperPlacement, middleware: me([
      us({ padding: 15 }),
      cs(10),
      ds({ element: o })
    ], (e = t.popperModifiers) !== null && e !== void 0 ? e : [], !0) }, t.popperProps)), i = F(F({}, t), { hidePopper: r, popperProps: F(F({}, s), { arrowRef: o }) });
    return m.createElement(n, F({}, i));
  };
  return a;
}
var yi = (
  /** @class */
  function(n) {
    ee(a, n);
    function a() {
      return n !== null && n.apply(this, arguments) || this;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          hidePopper: !0
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.render = function() {
      var t = this.props, e = t.className, r = t.wrapperClassName, o = t.hidePopper, s = o === void 0 ? a.defaultProps.hidePopper : o, i = t.popperComponent, l = t.targetComponent, c = t.enableTabLoop, u = t.popperOnKeyDown, d = t.portalId, p = t.portalHost, f = t.popperProps, h = t.showArrow, v = void 0;
      if (!s) {
        var g = Z("react-datepicker-popper", e);
        v = m.createElement(
          Ln,
          { enableTabLoop: c },
          m.createElement(
            "div",
            { ref: f.refs.setFloating, style: f.floatingStyles, className: g, "data-placement": f.placement, onKeyDown: u },
            i,
            h && m.createElement(ys, { ref: f.arrowRef, context: f.context, fill: "currentColor", strokeWidth: 1, height: 8, width: 16, style: { transform: "translateY(-1px)" }, className: "react-datepicker__triangle" })
          )
        );
      }
      this.props.popperContainer && (v = Wn(this.props.popperContainer, {}, v)), d && !s && (v = m.createElement(In, { portalId: d, portalHost: p }, v));
      var D = Z("react-datepicker-wrapper", r);
      return m.createElement(
        m.Fragment,
        null,
        m.createElement("div", { ref: f.refs.setReference, className: D }, l),
        v
      );
    }, a;
  }(J)
), bi = wi(yi), en = "react-datepicker-ignore-onclickoutside";
function _i(n, a) {
  return n && a ? ne(n) !== ne(a) || R(n) !== R(a) : n !== a;
}
var Xt = "Date input not valid.", ki = (
  /** @class */
  function(n) {
    ee(a, n);
    function a(t) {
      var e = n.call(this, t) || this;
      return e.calendar = null, e.input = null, e.getPreSelection = function() {
        return e.props.openToDate ? e.props.openToDate : e.props.selectsEnd && e.props.startDate ? e.props.startDate : e.props.selectsStart && e.props.endDate ? e.props.endDate : B();
      }, e.modifyHolidays = function() {
        var r;
        return (r = e.props.holidays) === null || r === void 0 ? void 0 : r.reduce(function(o, s) {
          var i = new Date(s.date);
          return _e(i) ? me(me([], o, !0), [F(F({}, s), { date: i })], !1) : o;
        }, []);
      }, e.calcInitialState = function() {
        var r, o = e.getPreSelection(), s = Nn(e.props), i = Rn(e.props), l = s && Fe(o, bt(s)) ? s : i && Oe(o, Hr(i)) ? i : o;
        return {
          open: e.props.startOpen || !1,
          preventFocus: !1,
          inputValue: null,
          preSelection: (r = e.props.selectsRange ? e.props.startDate : e.props.selected) !== null && r !== void 0 ? r : l,
          // transforming highlighted days (perhaps nested array)
          // to flat Map for faster access in day.jsx
          highlightDates: $r(e.props.highlightDates),
          focused: !1,
          // used to focus day in inline version after month has changed, but not on
          // initial render
          shouldFocusDayInline: !1,
          isRenderAriaLiveMessage: !1,
          wasHidden: !1
        };
      }, e.resetHiddenStatus = function() {
        e.setState(F(F({}, e.state), { wasHidden: !1 }));
      }, e.setHiddenStatus = function() {
        e.setState(F(F({}, e.state), { wasHidden: !0 }));
      }, e.setHiddenStateOnVisibilityHidden = function() {
        document.visibilityState === "hidden" && e.setHiddenStatus();
      }, e.clearPreventFocusTimeout = function() {
        e.preventFocusTimeout && clearTimeout(e.preventFocusTimeout);
      }, e.setFocus = function() {
        e.input && e.input.focus && e.input.focus({ preventScroll: !0 });
      }, e.setBlur = function() {
        e.input && e.input.blur && e.input.blur(), e.cancelFocusInput();
      }, e.setOpen = function(r, o) {
        o === void 0 && (o = !1), e.setState({
          open: r,
          preSelection: r && e.state.open ? e.state.preSelection : e.calcInitialState().preSelection,
          lastPreSelectChange: Gt
        }, function() {
          r || e.setState(function(s) {
            return {
              focused: o ? s.focused : !1
            };
          }, function() {
            !o && e.setBlur(), e.setState({ inputValue: null });
          });
        });
      }, e.inputOk = function() {
        return Se(e.state.preSelection);
      }, e.isCalendarOpen = function() {
        return e.props.open === void 0 ? e.state.open && !e.props.disabled && !e.props.readOnly : e.props.open;
      }, e.handleFocus = function(r) {
        var o, s, i = e.state.wasHidden, l = i ? e.state.open : !0;
        i && e.resetHiddenStatus(), !e.state.preventFocus && l && ((s = (o = e.props).onFocus) === null || s === void 0 || s.call(o, r), !e.props.preventOpenOnFocus && !e.props.readOnly && e.setOpen(!0)), e.setState({ focused: !0 });
      }, e.sendFocusBackToInput = function() {
        e.preventFocusTimeout && e.clearPreventFocusTimeout(), e.setState({ preventFocus: !0 }, function() {
          e.preventFocusTimeout = setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        });
      }, e.cancelFocusInput = function() {
        clearTimeout(e.inputFocusTimeout), e.inputFocusTimeout = void 0;
      }, e.deferFocusInput = function() {
        e.cancelFocusInput(), e.inputFocusTimeout = setTimeout(function() {
          return e.setFocus();
        }, 1);
      }, e.handleDropdownFocus = function() {
        e.cancelFocusInput();
      }, e.handleBlur = function(r) {
        var o, s;
        (!e.state.open || e.props.withPortal || e.props.showTimeInput) && ((s = (o = e.props).onBlur) === null || s === void 0 || s.call(o, r)), e.setState({ focused: !1 });
      }, e.handleCalendarClickOutside = function(r) {
        var o, s;
        e.props.inline || e.setOpen(!1), (s = (o = e.props).onClickOutside) === null || s === void 0 || s.call(o, r), e.props.withPortal && r.preventDefault();
      }, e.handleChange = function() {
        for (var r, o, s = [], i = 0; i < arguments.length; i++)
          s[i] = arguments[i];
        var l = s[0];
        if (!(e.props.onChangeRaw && (e.props.onChangeRaw.apply(e, s), !l || typeof l.isDefaultPrevented != "function" || l.isDefaultPrevented()))) {
          e.setState({
            inputValue: (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : null,
            lastPreSelectChange: xi
          });
          var c = e.props, u = c.dateFormat, d = u === void 0 ? a.defaultProps.dateFormat : u, p = c.strictParsing, f = p === void 0 ? a.defaultProps.strictParsing : p, h = c.selectsRange, v = c.startDate, g = c.endDate, D = (l == null ? void 0 : l.target) instanceof HTMLInputElement ? l.target.value : "";
          if (h) {
            var M = D.split("-", 2).map(function(L) {
              return L.trim();
            }), k = M[0], E = M[1], S = $t(k ?? "", d, e.props.locale, f), O = $t(E ?? "", d, e.props.locale, f), y = (v == null ? void 0 : v.getTime()) !== (S == null ? void 0 : S.getTime()), _ = (g == null ? void 0 : g.getTime()) !== (O == null ? void 0 : O.getTime());
            if (!y && !_ || S && ie(S, e.props) || O && ie(O, e.props))
              return;
            (o = (r = e.props).onChange) === null || o === void 0 || o.call(r, [S, O], l);
          } else {
            var C = $t(D, d, e.props.locale, f, e.props.minDate);
            e.props.showTimeSelectOnly && e.props.selected && C && !I(C, e.props.selected) && (C = xo(e.props.selected, {
              hours: ve(C),
              minutes: ge(C),
              seconds: xe(C)
            })), (C || !D) && e.setSelected(C, l, !0);
          }
        }
      }, e.handleSelect = function(r, o, s) {
        if (e.props.shouldCloseOnSelect && !e.props.showTimeSelect && e.sendFocusBackToInput(), e.props.onChangeRaw && e.props.onChangeRaw(o), e.setSelected(r, o, !1, s), e.props.showDateSelect && e.setState({ isRenderAriaLiveMessage: !0 }), !e.props.shouldCloseOnSelect || e.props.showTimeSelect)
          e.setPreSelection(r);
        else if (!e.props.inline) {
          e.props.selectsRange || e.setOpen(!1);
          var i = e.props, l = i.startDate, c = i.endDate;
          l && !c && (e.props.swapRange || !Gr(r, l)) && e.setOpen(!1);
        }
      }, e.setSelected = function(r, o, s, i) {
        var l, c, u = r;
        if (e.props.showYearPicker) {
          if (u !== null && _t(R(u), e.props))
            return;
        } else if (e.props.showMonthYearPicker) {
          if (u !== null && On(u, e.props))
            return;
        } else if (u !== null && ie(u, e.props))
          return;
        var d = e.props, p = d.onChange, f = d.selectsRange, h = d.startDate, v = d.endDate, g = d.selectsMultiple, D = d.selectedDates, M = d.minTime, k = d.swapRange;
        if (!Re(e.props.selected, u) || e.props.allowSameDay || f || g)
          if (u !== null && (e.props.selected && (!s || !e.props.showTimeSelect && !e.props.showTimeSelectOnly && !e.props.showTimeInput) && (u = jt(u, {
            hour: ve(e.props.selected),
            minute: ge(e.props.selected),
            second: xe(e.props.selected)
          })), !s && (e.props.showTimeSelect || e.props.showTimeSelectOnly) && M && (u = jt(u, {
            hour: M.getHours(),
            minute: M.getMinutes(),
            second: M.getSeconds()
          })), e.props.inline || e.setState({
            preSelection: u
          }), e.props.focusSelectedMonth || e.setState({ monthSelectedIn: i })), f) {
            var E = !h && !v, S = h && !v, O = h && v;
            E ? p == null || p([u, null], o) : S && (u === null ? p == null || p([null, null], o) : Gr(u, h) ? k ? p == null || p([u, h], o) : p == null || p([u, null], o) : p == null || p([h, u], o)), O && (p == null || p([u, null], o));
          } else if (g) {
            if (u !== null)
              if (!(D != null && D.length))
                p == null || p([u], o);
              else {
                var y = D.some(function(C) {
                  return I(C, u);
                });
                if (y) {
                  var _ = D.filter(function(C) {
                    return !I(C, u);
                  });
                  p == null || p(_, o);
                } else
                  p == null || p(me(me([], D, !0), [u], !1), o);
              }
          } else
            p == null || p(u, o);
        s || ((c = (l = e.props).onSelect) === null || c === void 0 || c.call(l, u, o), e.setState({ inputValue: null }));
      }, e.setPreSelection = function(r) {
        var o = Se(e.props.minDate), s = Se(e.props.maxDate), i = !0;
        if (r) {
          var l = bt(r);
          if (o && s)
            i = Ge(r, e.props.minDate, e.props.maxDate);
          else if (o) {
            var c = bt(e.props.minDate);
            i = Oe(r, c) || Re(l, c);
          } else if (s) {
            var u = Hr(e.props.maxDate);
            i = Fe(r, u) || Re(l, u);
          }
        }
        i && e.setState({
          preSelection: r
        });
      }, e.toggleCalendar = function() {
        e.setOpen(!e.state.open);
      }, e.handleTimeChange = function(r) {
        var o, s;
        if (!(e.props.selectsRange || e.props.selectsMultiple)) {
          var i = e.props.selected ? e.props.selected : e.getPreSelection(), l = e.props.selected ? r : jt(i, {
            hour: ve(r),
            minute: ge(r)
          });
          e.setState({
            preSelection: l
          }), (s = (o = e.props).onChange) === null || s === void 0 || s.call(o, l), e.props.shouldCloseOnSelect && !e.props.showTimeInput && (e.sendFocusBackToInput(), e.setOpen(!1)), e.props.showTimeInput && e.setOpen(!0), (e.props.showTimeSelectOnly || e.props.showTimeSelect) && e.setState({ isRenderAriaLiveMessage: !0 }), e.setState({ inputValue: null });
        }
      }, e.onInputClick = function() {
        var r, o;
        !e.props.disabled && !e.props.readOnly && e.setOpen(!0), (o = (r = e.props).onInputClick) === null || o === void 0 || o.call(r);
      }, e.onInputKeyDown = function(r) {
        var o, s, i, l, c, u;
        (s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, r);
        var d = r.key;
        if (!e.state.open && !e.props.inline && !e.props.preventOpenOnFocus) {
          (d === w.ArrowDown || d === w.ArrowUp || d === w.Enter) && ((i = e.onInputClick) === null || i === void 0 || i.call(e));
          return;
        }
        if (e.state.open) {
          if (d === w.ArrowDown || d === w.ArrowUp) {
            r.preventDefault();
            var p = e.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : e.props.showWeekPicker && e.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : e.props.showFullMonthYearPicker || e.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', f = ((l = e.calendar) === null || l === void 0 ? void 0 : l.containerRef.current) instanceof Element && e.calendar.containerRef.current.querySelector(p);
            f instanceof HTMLElement && f.focus({ preventScroll: !0 });
            return;
          }
          var h = B(e.state.preSelection);
          d === w.Enter ? (r.preventDefault(), e.inputOk() && e.state.lastPreSelectChange === Gt ? (e.handleSelect(h, r), !e.props.shouldCloseOnSelect && e.setPreSelection(h)) : e.setOpen(!1)) : d === w.Escape ? (r.preventDefault(), e.sendFocusBackToInput(), e.setOpen(!1)) : d === w.Tab && e.setOpen(!1), e.inputOk() || (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: Xt });
        }
      }, e.onPortalKeyDown = function(r) {
        var o = r.key;
        o === w.Escape && (r.preventDefault(), e.setState({
          preventFocus: !0
        }, function() {
          e.setOpen(!1), setTimeout(function() {
            e.setFocus(), e.setState({ preventFocus: !1 });
          });
        }));
      }, e.onDayKeyDown = function(r) {
        var o, s, i, l, c, u, d = e.props, p = d.minDate, f = d.maxDate, h = d.disabledKeyboardNavigation, v = d.showWeekPicker, g = d.shouldCloseOnSelect, D = d.locale, M = d.calendarStartDay, k = d.adjustDateOnChange, E = d.inline;
        if ((s = (o = e.props).onKeyDown) === null || s === void 0 || s.call(o, r), !h) {
          var S = r.key, O = r.shiftKey, y = B(e.state.preSelection), _ = function(Q, T) {
            var Y = T;
            switch (Q) {
              case w.ArrowRight:
                Y = v ? Mt(T, 1) : Te(T, 1);
                break;
              case w.ArrowLeft:
                Y = v ? Er(T, 1) : Xn(T, 1);
                break;
              case w.ArrowUp:
                Y = Er(T, 1);
                break;
              case w.ArrowDown:
                Y = Mt(T, 1);
                break;
              case w.PageUp:
                Y = O ? Ke(T, 1) : Qe(T, 1);
                break;
              case w.PageDown:
                Y = O ? ke(T, 1) : we(T, 1);
                break;
              case w.Home:
                Y = Ee(T, D, M);
                break;
              case w.End:
                Y = Is(T);
                break;
            }
            return Y;
          }, C = function(Q, T) {
            for (var Y = 40, N = Q, X = !1, ce = 0, ue = _(Q, T); !X; ) {
              if (ce >= Y) {
                ue = T;
                break;
              }
              p && ue < p && (N = w.ArrowRight, ue = ie(p, e.props) ? _(N, ue) : p), f && ue > f && (N = w.ArrowLeft, ue = ie(f, e.props) ? _(N, ue) : f), ie(ue, e.props) ? ((N === w.PageUp || N === w.Home) && (N = w.ArrowRight), (N === w.PageDown || N === w.End) && (N = w.ArrowLeft), ue = _(N, ue)) : X = !0, ce++;
            }
            return ue;
          };
          if (S === w.Enter) {
            r.preventDefault(), e.handleSelect(y, r), !g && e.setPreSelection(y);
            return;
          } else if (S === w.Escape) {
            r.preventDefault(), e.setOpen(!1), e.inputOk() || (l = (i = e.props).onInputError) === null || l === void 0 || l.call(i, { code: 1, msg: Xt });
            return;
          }
          var L = null;
          switch (S) {
            case w.ArrowLeft:
            case w.ArrowRight:
            case w.ArrowUp:
            case w.ArrowDown:
            case w.PageUp:
            case w.PageDown:
            case w.Home:
            case w.End:
              L = C(S, y);
              break;
          }
          if (!L) {
            (u = (c = e.props).onInputError) === null || u === void 0 || u.call(c, { code: 1, msg: Xt });
            return;
          }
          if (r.preventDefault(), e.setState({ lastPreSelectChange: Gt }), k && e.setSelected(L), e.setPreSelection(L), E) {
            var W = ne(y), A = ne(L), K = R(y), V = R(L);
            W !== A || K !== V ? e.setState({ shouldFocusDayInline: !0 }) : e.setState({ shouldFocusDayInline: !1 });
          }
        }
      }, e.onPopperKeyDown = function(r) {
        var o = r.key;
        o === w.Escape && (r.preventDefault(), e.sendFocusBackToInput());
      }, e.onClearClick = function(r) {
        r && r.preventDefault && r.preventDefault(), e.sendFocusBackToInput();
        var o = e.props, s = o.selectsRange, i = o.onChange;
        s ? i == null || i([null, null], r) : i == null || i(null, r), e.setState({ inputValue: null });
      }, e.clear = function() {
        e.onClearClick();
      }, e.onScroll = function(r) {
        typeof e.props.closeOnScroll == "boolean" && e.props.closeOnScroll ? (r.target === document || r.target === document.documentElement || r.target === document.body) && e.setOpen(!1) : typeof e.props.closeOnScroll == "function" && e.props.closeOnScroll(r) && e.setOpen(!1);
      }, e.renderCalendar = function() {
        var r, o;
        return !e.props.inline && !e.isCalendarOpen() ? null : m.createElement(mi, F({ showMonthYearDropdown: void 0, ref: function(s) {
          e.calendar = s;
        } }, e.props, e.state, { setOpen: e.setOpen, dateFormat: (r = e.props.dateFormatCalendar) !== null && r !== void 0 ? r : a.defaultProps.dateFormatCalendar, onSelect: e.handleSelect, onClickOutside: e.handleCalendarClickOutside, holidays: $s(e.modifyHolidays()), outsideClickIgnoreClass: en, onDropdownFocus: e.handleDropdownFocus, onTimeChange: e.handleTimeChange, className: e.props.calendarClassName, container: e.props.calendarContainer, handleOnKeyDown: e.props.onKeyDown, handleOnDayKeyDown: e.onDayKeyDown, setPreSelection: e.setPreSelection, dropdownMode: (o = e.props.dropdownMode) !== null && o !== void 0 ? o : a.defaultProps.dropdownMode }), e.props.children);
      }, e.renderAriaLiveRegion = function() {
        var r = e.props, o = r.dateFormat, s = o === void 0 ? a.defaultProps.dateFormat : o, i = r.locale, l = e.props.showTimeInput || e.props.showTimeSelect, c = l ? "PPPPp" : "PPPP", u;
        return e.props.selectsRange ? u = "Selected start date: ".concat(se(e.props.startDate, {
          dateFormat: c,
          locale: i
        }), ". ").concat(e.props.endDate ? "End date: " + se(e.props.endDate, {
          dateFormat: c,
          locale: i
        }) : "") : e.props.showTimeSelectOnly ? u = "Selected time: ".concat(se(e.props.selected, { dateFormat: s, locale: i })) : e.props.showYearPicker ? u = "Selected year: ".concat(se(e.props.selected, { dateFormat: "yyyy", locale: i })) : e.props.showMonthYearPicker ? u = "Selected month: ".concat(se(e.props.selected, { dateFormat: "MMMM yyyy", locale: i })) : e.props.showQuarterYearPicker ? u = "Selected quarter: ".concat(se(e.props.selected, {
          dateFormat: "yyyy, QQQ",
          locale: i
        })) : u = "Selected date: ".concat(se(e.props.selected, {
          dateFormat: c,
          locale: i
        })), m.createElement("span", { role: "alert", "aria-live": "polite", className: "react-datepicker__aria-live" }, u);
      }, e.renderDateInput = function() {
        var r, o, s, i = Z(e.props.className, (r = {}, r[en] = e.state.open, r)), l = e.props.customInput || m.createElement("input", { type: "text" }), c = e.props.customInputRef || "ref", u = e.props, d = u.dateFormat, p = d === void 0 ? a.defaultProps.dateFormat : d, f = u.locale, h = typeof e.props.value == "string" ? e.props.value : typeof e.state.inputValue == "string" ? e.state.inputValue : e.props.selectsRange ? Os(e.props.startDate, e.props.endDate, {
          dateFormat: p,
          locale: f
        }) : e.props.selectsMultiple ? Ns((s = e.props.selectedDates) !== null && s !== void 0 ? s : [], {
          dateFormat: p,
          locale: f
        }) : se(e.props.selected, {
          dateFormat: p,
          locale: f
        });
        return rn(l, (o = {}, o[c] = function(v) {
          e.input = v;
        }, o.value = h, o.onBlur = e.handleBlur, o.onChange = e.handleChange, o.onClick = e.onInputClick, o.onFocus = e.handleFocus, o.onKeyDown = e.onInputKeyDown, o.id = e.props.id, o.name = e.props.name, o.form = e.props.form, o.autoFocus = e.props.autoFocus, o.placeholder = e.props.placeholderText, o.disabled = e.props.disabled, o.autoComplete = e.props.autoComplete, o.className = Z(l.props.className, i), o.title = e.props.title, o.readOnly = e.props.readOnly, o.required = e.props.required, o.tabIndex = e.props.tabIndex, o["aria-describedby"] = e.props.ariaDescribedBy, o["aria-invalid"] = e.props.ariaInvalid, o["aria-labelledby"] = e.props.ariaLabelledBy, o["aria-required"] = e.props.ariaRequired, o));
      }, e.renderClearButton = function() {
        var r = e.props, o = r.isClearable, s = r.disabled, i = r.selected, l = r.startDate, c = r.endDate, u = r.clearButtonTitle, d = r.clearButtonClassName, p = d === void 0 ? "" : d, f = r.ariaLabelClose, h = f === void 0 ? "Close" : f, v = r.selectedDates;
        return o && (i != null || l != null || c != null || v != null && v.length) ? m.createElement("button", { type: "button", className: Z("react-datepicker__close-icon", p, { "react-datepicker__close-icon--disabled": s }), disabled: s, "aria-label": h, onClick: e.onClearClick, title: u, tabIndex: -1 }) : null;
      }, e.state = e.calcInitialState(), e.preventFocusTimeout = void 0, e;
    }
    return Object.defineProperty(a, "defaultProps", {
      get: function() {
        return {
          allowSameDay: !1,
          dateFormat: "MM/dd/yyyy",
          dateFormatCalendar: "LLLL yyyy",
          disabled: !1,
          disabledKeyboardNavigation: !1,
          dropdownMode: "scroll",
          preventOpenOnFocus: !1,
          monthsShown: 1,
          readOnly: !1,
          withPortal: !1,
          selectsDisabledDaysInRange: !1,
          shouldCloseOnSelect: !0,
          showTimeSelect: !1,
          showTimeInput: !1,
          showPreviousMonths: !1,
          showMonthYearPicker: !1,
          showFullMonthYearPicker: !1,
          showTwoColumnMonthYearPicker: !1,
          showFourColumnMonthYearPicker: !1,
          showYearPicker: !1,
          showQuarterYearPicker: !1,
          showWeekPicker: !1,
          strictParsing: !1,
          swapRange: !1,
          timeIntervals: 30,
          timeCaption: "Time",
          previousMonthAriaLabel: "Previous Month",
          previousMonthButtonLabel: "Previous Month",
          nextMonthAriaLabel: "Next Month",
          nextMonthButtonLabel: "Next Month",
          previousYearAriaLabel: "Previous Year",
          previousYearButtonLabel: "Previous Year",
          nextYearAriaLabel: "Next Year",
          nextYearButtonLabel: "Next Year",
          timeInputLabel: "Time",
          enableTabLoop: !0,
          yearItemNumber: it,
          focusSelectedMonth: !1,
          showPopperArrow: !0,
          excludeScrollbar: !0,
          customTimeInput: null,
          calendarStartDay: void 0,
          toggleCalendarOnIconClick: !1,
          usePointerEvent: !1
        };
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.componentDidMount = function() {
      window.addEventListener("scroll", this.onScroll, !0), document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.componentDidUpdate = function(t, e) {
      var r, o, s, i;
      t.inline && _i(t.selected, this.props.selected) && this.setPreSelection(this.props.selected), this.state.monthSelectedIn !== void 0 && t.monthsShown !== this.props.monthsShown && this.setState({ monthSelectedIn: 0 }), t.highlightDates !== this.props.highlightDates && this.setState({
        highlightDates: $r(this.props.highlightDates)
      }), !e.focused && !Re(t.selected, this.props.selected) && this.setState({ inputValue: null }), e.open !== this.state.open && (e.open === !1 && this.state.open === !0 && ((o = (r = this.props).onCalendarOpen) === null || o === void 0 || o.call(r)), e.open === !0 && this.state.open === !1 && ((i = (s = this.props).onCalendarClose) === null || i === void 0 || i.call(s)));
    }, a.prototype.componentWillUnmount = function() {
      this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0), document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    }, a.prototype.renderInputContainer = function() {
      var t = this.props, e = t.showIcon, r = t.icon, o = t.calendarIconClassname, s = t.calendarIconClassName, i = t.toggleCalendarOnIconClick, l = this.state.open;
      return o && console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props."), m.createElement(
        "div",
        { className: "react-datepicker__input-container".concat(e ? " react-datepicker__view-calendar-icon" : "") },
        e && m.createElement(vi, F({ icon: r, className: Z(s, !s && o, l && "react-datepicker-ignore-onclickoutside") }, i ? {
          onClick: this.toggleCalendar
        } : null)),
        this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(),
        this.renderDateInput(),
        this.renderClearButton()
      );
    }, a.prototype.render = function() {
      var t = this.renderCalendar();
      if (this.props.inline)
        return t;
      if (this.props.withPortal) {
        var e = this.state.open ? m.createElement(
          Ln,
          { enableTabLoop: this.props.enableTabLoop },
          m.createElement("div", { className: "react-datepicker__portal", tabIndex: -1, onKeyDown: this.onPortalKeyDown }, t)
        ) : null;
        return this.state.open && this.props.portalId && (e = m.createElement(In, F({ portalId: this.props.portalId }, this.props), e)), m.createElement(
          "div",
          null,
          this.renderInputContainer(),
          e
        );
      }
      return m.createElement(bi, F({}, this.props, { className: this.props.popperClassName, hidePopper: !this.isCalendarOpen(), targetComponent: this.renderInputContainer(), popperComponent: t, popperOnKeyDown: this.onPopperKeyDown, showArrow: this.props.showPopperArrow }));
    }, a;
  }(J)
), xi = "input", Gt = "navigate";
function Ri({
  onChange: n = null,
  name: a = "selectedDate",
  selected: t = null,
  label: e = "",
  width: r = 100,
  helpText: o = "",
  ...s
}) {
  const i = kt(null), [l, c] = Qn(t), u = (p) => {
    c(p), i !== null && (i.current.value = er(p, "yyyy-MM-dd"));
  }, d = Kn(({ value: p, onClick: f }, h) => /* @__PURE__ */ ct(Jn, { onClick: f, defaultValue: p, label: e, width: r, showValidation: !1, helpText: o, ref: h }));
  return /* @__PURE__ */ Hn(
    "div",
    {
      onClick: (p) => {
        p.target.classList.contains("react-datepicker__day") || p.stopPropagation();
      },
      style: {
        display: "contents",
        "--react-datepicker-wrapper-width": `${r}%`
      },
      children: [
        /* @__PURE__ */ ct(
          ki,
          {
            onChange: n ?? u,
            selected: l,
            customInput: /* @__PURE__ */ ct(d, {}),
            ...s
          }
        ),
        /* @__PURE__ */ ct("input", { type: "hidden", ref: i, name: a })
      ]
    }
  );
}
export {
  Ri as DatePicker,
  Ri as default
};
